/**
 * 交付项目时场景不可留有log ***
 * 记得开启
 */
// const console = {
//   log: () => { },
// };
import E from "run-scene-v2";
const { Utils } = E;
import * as THREE from "three";
import bus from "./Bus";
import { allGroup } from "./AllGroup";
import NameDispose from "./jc";
import router from "../../router";
import { Object3D } from "three";
// 声明变量

const test1 = {
  beyondAlarm: [],
  fault: [],
  normal: [
    "05-B01-025-WM-26-050107",
    "05-B01-025-WM-26-050106",
    "05-B01-025-WM-26-050102",
    "05-B01-025-WM-26-050101",
    "05-B01-025-WM-26-050103",
    "05-B01-025-WM-26-050104",
    "05-B01-025-WM-26-050105",
  ],
  standby: [],
};

const test2 = {
  beyondAlarm: [],
  fault: [
    "05-B01-025-WM-26-050101",
    "05-B01-025-WM-26-050103",
    "05-B01-025-WM-26-050104",
    "05-B01-025-WM-26-050105",
  ],
  normal: [
    "05-B01-025-WM-26-050107",
    "05-B01-025-WM-26-050106",
    "05-B01-025-WM-26-050102",
  ],
  standby: [],
};

let camera, scene, controls, renderer2, renderer, dom, t, p, runScene, Bus;

// 工具
const { getRes, getMacro } = Utils;

// 拿资源
const setAssets = (assets) => {
  camera = assets.camera;
  scene = assets.scene;
  controls = assets.controls;
  renderer = assets.renderer;
  dom = assets.engineDom;
  t = assets.t;
  // renderer2 = assets.renderer2;
  // p = assets.p;
};
//  页面接口总出口
function Change(runScene) {
  /* 拿资源 分解资源
                                      this挂载至t上
                                      runScene上的其他Api可以直接runScene.直接使用
                                    */
  setAssets({
    ...runScene.assetsEx.get(),
    t: this,
    runScene,
  });

  // 挂载runScene
  t.runScene = runScene;
  // 最后一帧加载回调
  runScene.on("complete", () => {
    // 左右键替换
    controls.mouseButtons = {
      ORBIT: 2,
      PAN: 0,
      ZOOM: 1,
    };
    // 最小距离
    // controls.minDistance = 60;
    // 最大距离
    // controls.maxDistance = 400;

    // 每帧渲染
    // t.runScene.cb.render.add("每帧渲染注册名称", () => { });
    t.runScene.modelEx.camAnima(
      t.runScene.modelEx.getCamLocal(),
      {
        cx: -195.77154991022059,
        cy: 108.86415517224904,
        cz: 336.52840544622154,
        tx: 25.060879026295346,
        ty: -18.208086287267943,
        tz: 64.57891460682868,
      },
      1
    );
    this.pdjevent = new Pdjevent();
    this.pdjevent.init();


    this.hover = new Hover();
    this.hover.init();

    this.map = new Map();
    this.map.init();

    this.floor = new Floor();
    this.floor.init();

    this.shuipump = new Shuipump();
    this.shuipump.init();


    this.border = new Border();
    this.border.init();


    this.parking = new Parking();
    this.parking.init();

    this.ponintstate = new Ponintstate();
    this.ponintstate.init();

    this.switchover = new Switchover();
    this.switchover.init();


    this.events = new Events();

    this.busEvent = new BusEvent();
    this.busEvent.init();

    // t.runScene.modelEx.instance(scene);

    controls.maxPolarAngle = Math.PI / 2 - 0.2;

    controls.screenSpacePanning = false;
    // 脚本播放
    t.runScene.script.playAll();
    // setTimeout(() => {
    //     console.log(t.runScene)
    //     let model1 = t.runScene.modelEx.getModel('04-A01-001-DT-16-000001_电梯框');
    //     console.log(model1, "model1model1");
    // }, 1000)
  });

  // 销毁
  this.dispose = () => runScene.dispose();
}
class Floor {
  constructor() { }
  Builddings = {};
  floorMap;
  textureMap = {};
  pointTextureMap;
  moveHeight = 16.5;
  chosenFloor = 0; //选择的楼层
  chosenBuilding = null;
  showFloorBq = false;
  typePoint = null;
  backAnima = null;
  shellVisible = true;
  light = null;
  lift = {};
  liftKuang = {};
  testPoint = [];
  clickPointTextureMap;
  hoverPointTextureMap;
  findModel;
  // hoverPointName = '';
  currentPrice = null;
  clickPointName = "";
  myPointStateMap = null;
  clickFloor = null;
  isBackView = true;
  buildNoMap = {
    B3: "04",
    B1B2: "03",
    A2: "02",
    A1: "01",
  };
  floorLiftPosY = {
    B1: -10,
    A1: -6,
    A2: -1,
    A3: 3,
    A4: 7,
    A5: 11,
  };
  floorOldPosition = {
    B3: {
      F1: 0,
      F2: 0,
      F3: 0,
      F4: 0,
      F5: 0,
    },
    A1: {
      F1: 0,
      F2: 0,
      F3: 0,
      F4: 0,
      F5: 0,
    },
    A2: {
      F1: 0,
      F2: 0,
      F3: 0,
      F4: 0,
      F5: 0,
    },
    B1B2: {
      F1: 0,
      F2: 0,
      F3: 0,
      F4: 0,
      F5: 0,
    },
  }; //楼层初始位置
  floorGoPosition = {
    B3: {
      F1: 0,
      F2: 0,
      F3: 0,
      F4: 0,
      F5: 0,
    },
    A1: {
      F1: 0,
      F2: 0,
      F3: 0,
      F4: 0,
      F5: 0,
    },
    A2: {
      F1: 0,
      F2: 0,
      F3: 0,
      F4: 0,
      F5: 0,
    },
    B1B2: {
      F1: 0,
      F2: 0,
      F3: 0,
      F4: 0,
      F5: 0,
    },
  };
  liftColor = {
    // 上行: {
    //     r: 0,
    //     g: 187,
    //     b: 255,
    // },
    // 下行: {
    //     r: 0,
    //     g: 187,
    //     b: 255,
    // },
    // 静止: {
    //     r: 255,
    //     g: 255,
    //     b: 255,
    // },
    // 暂无数据: {
    //     r: 255,
    //     g: 255,
    //     b: 255,
    // },
    0: {
      lift: {
        r: 71,
        g: 71,
        b: 71,
      },
      liftKuang: {
        r: 255,
        g: 255,
        b: 255,
      },
    },
    1: {
      lift: {
        r: 0,
        g: 187,
        b: 255,
      },
      liftKuang: {
        r: 54,
        g: 78,
        b: 255,
      },
    },
    2: {
      lift: {
        r: 254,
        g: 74,
        b: 20,
      },
      liftKuang: {
        r: 255,
        g: 52,
        b: 21,
      },
    },
    3: {
      lift: {
        r: 254,
        g: 74,
        b: 20,
      },
      liftKuang: {
        r: 255,
        g: 52,
        b: 21,
      },
    },
  };
  liftEmissive = {
    0: {
      lift: {
        r: 0,
        g: 0,
        b: 0,
      },
      liftKuang: {
        r: 255,
        g: 255,
        b: 255,
      },
    },
    1: {
      lift: {
        r: 0,
        g: 57,
        b: 125,
      },
      liftKuang: {
        r: 5,
        g: 34,
        b: 255,
      },
    },
    2: {
      lift: {
        r: 0,
        g: 0,
        b: 0,
      },
      liftKuang: {
        r: 255,
        g: 77,
        b: 0,
      },
    },
    3: {
      lift: {
        r: 0,
        g: 0,
        b: 0,
      },
      liftKuang: {
        r: 255,
        g: 77,
        b: 0,
      },
    },
  };
  liftMap = {
    1: t.map.createMap("./assets/blue.png"),
    2: t.map.createMap("./assets/yellow.png"),
    3: t.map.createMap("./assets/yellow.png"),
  };
  queryTimer = null; //轮询
  init() {
    this.light = t.runScene.tags
      .get("发光")
      .map((id) => t.runScene.uniqueEx.model.get(id))
      .filter((i) => i);
    // t.runScene.modelEx.getModel('guangxiao');
    // this.light.visible = false;
    this.setLight(false);
    this.Builddings = {
      B3: {
        shell: t.runScene.modelEx.getModel("B3"),
        floor: {
          F1: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("B3_F1_楼层"),
              t.runScene.modelEx.getModel("B3_F1_TX"),
              t.runScene.modelEx.getModel("B3_F1_特殊房间"),
            ],
          },
          F2: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            vrv空调: null,
            监控: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("B3_F2_楼层"),
              t.runScene.modelEx.getModel("B3_F2_TX"),
              t.runScene.modelEx.getModel("B3_F2_特殊房间"),
            ],
          },
          F3: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("B3_F3_楼层"),
              t.runScene.modelEx.getModel("B3_F3_TX"),
              t.runScene.modelEx.getModel("B3_F3_特殊房间"),
            ],
          },
          F4: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("B3_F4_楼层"),
              t.runScene.modelEx.getModel("B3_F4_TX"),
              t.runScene.modelEx.getModel("B3_F4_特殊房间"),
            ],
          },
          F5: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("B3_F5_楼层"),
              t.runScene.modelEx.getModel("B3_F5_TX"),
              t.runScene.modelEx.getModel("B3_F5_特殊房间"),
            ],
          },
          F6: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            content: [
              t.runScene.modelEx.getModel("B3_F6_楼层"),
              t.runScene.modelEx.getModel("B3_F6_TX"),
            ],
          },
        },
        floorBq: [
          t.runScene.modelEx.getModel("B3_F1标签"),
          t.runScene.modelEx.getModel("B3_F2标签"),
          t.runScene.modelEx.getModel("B3_F3标签"),
          t.runScene.modelEx.getModel("B3_F4标签"),
          t.runScene.modelEx.getModel("B3_F5标签"),
          t.runScene.modelEx.getModel("B3_F6标签"),
        ],
        lift: t.runScene.modelEx.getModel("B3内容_1"),
        view: {
          cx: -126.76985862228904,
          cy: 42.912066815729204,
          cz: 205.23741394305358,
          tx: 30.226832202821125,
          ty: -18.208086,
          tz: 205.85786515820013,
          // tx: 82.55716315291252,
          // ty: -18.208086,
          // tz: 200.46724372456995
        },
        chosenFloor: 0,
      },
      A1: {
        shell: t.runScene.modelEx.getModel("A1"),
        floor: {
          F1: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("A1_F1_楼层"),
              t.runScene.modelEx.getModel("A1_F1_TX"),
              t.runScene.modelEx.getModel("A1_F1_特殊房间"),
            ],
          },
          F2: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("A1_F2_楼层"),
              t.runScene.modelEx.getModel("A1_F2_TX"),
              t.runScene.modelEx.getModel("A1_F2_特殊房间"),
            ],
          },
          F3: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("A1_F3_楼层"),
              t.runScene.modelEx.getModel("A1_F3_TX"),
              t.runScene.modelEx.getModel("A1_F3_特殊房间"),
            ],
          },
          F4: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("A1_F4_楼层"),
              t.runScene.modelEx.getModel("A1_F4_TX"),
              t.runScene.modelEx.getModel("A1_F4_特殊房间"),
            ],
          },
          F5: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("A1_F5_楼层"),
              t.runScene.modelEx.getModel("A1_F5_TX"),
              t.runScene.modelEx.getModel("A1_F5_特殊房间"),
            ],
          },
          F6: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            content: [
              t.runScene.modelEx.getModel("A1_F6_楼层"),
              t.runScene.modelEx.getModel("A1_F6_TX"),
            ],
          },
        },
        floorBq: [
          t.runScene.modelEx.getModel("A1_F1标签"),
          t.runScene.modelEx.getModel("A1_F2标签"),
          t.runScene.modelEx.getModel("A1_F3标签"),
          t.runScene.modelEx.getModel("A1_F4标签"),
          t.runScene.modelEx.getModel("A1_F5标签"),
          t.runScene.modelEx.getModel("A1_F6标签"),
        ],
        lift: t.runScene.modelEx.getModel("A1内容_1"),
        view: {
          cx: -135.0083977922734,
          cy: 53.10508425181063,
          cz: -138.125214044826,
          tx: 29.14225566724474,
          ty: -18.208086,
          tz: -181.57266856389265,
        },
        chosenFloor: 0,
      },
      A2: {
        shell: t.runScene.modelEx.getModel("A2"),
        floor: {
          F1: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("A2_F1_楼层"),
              t.runScene.modelEx.getModel("A2_F1_TX"),
              t.runScene.modelEx.getModel("A2_F1_特殊房间"),
            ],
          },
          F2: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("A2_F2_楼层"),
              t.runScene.modelEx.getModel("A2_F2_TX"),
              t.runScene.modelEx.getModel("A2_F2_特殊房间"),
            ],
          },
          F3: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("A2_F3_楼层"),
              t.runScene.modelEx.getModel("A2_F3_TX"),
              t.runScene.modelEx.getModel("A2_F3_特殊房间"),
            ],
          },
          F4: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("A2_F4_楼层"),
              t.runScene.modelEx.getModel("A2_F4_TX"),
              t.runScene.modelEx.getModel("A2_F4_特殊房间"),
            ],
          },
          F5: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("A2_F5_楼层"),
              t.runScene.modelEx.getModel("A2_F5_TX"),
              t.runScene.modelEx.getModel("A2_F5_特殊房间"),
            ],
          },
          F6: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            content: [
              t.runScene.modelEx.getModel("A2_F6_楼层"),
              t.runScene.modelEx.getModel("A2_F6_TX"),
            ],
          },
        },
        floorBq: [
          t.runScene.modelEx.getModel("A2_F1标签"),
          t.runScene.modelEx.getModel("A2_F2标签"),
          t.runScene.modelEx.getModel("A2_F3标签"),
          t.runScene.modelEx.getModel("A2_F4标签"),
          t.runScene.modelEx.getModel("A2_F5标签"),
          t.runScene.modelEx.getModel("A2_F6标签"),
        ],
        lift: t.runScene.modelEx.getModel("A2内容_1"),
        view: {
          cx: -170.26272588619517,
          cy: 54.99565976366129,
          cz: -24.547517812461045,
          // tx: 73.70883807400656,
          // ty: -18.208086,
          // tz: -72.52174237923597
          tx: 35.182242512495039,
          ty: -18.208086,
          tz: -53.16104776830609,
        },
        chosenFloor: 0,
      },
      B1B2: {
        shell: t.runScene.modelEx.getModel("B1B2"),
        floor: {
          F1: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("B1B2_F1_楼层"),
              t.runScene.modelEx.getModel("B1B2_F1_TX"),
              t.runScene.modelEx.getModel("B1B2_F1_特殊房间"),
            ],
          },
          F2: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("B1B2_F2_楼层"),
              t.runScene.modelEx.getModel("B1B2_F2_TX"),
              t.runScene.modelEx.getModel("B1B2_F2_特殊房间"),
            ],
          },
          F3: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            监控: null,
            水空调: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("B1B2_F3_楼层"),
              t.runScene.modelEx.getModel("B1B2_F3_TX"),
              t.runScene.modelEx.getModel("B1B2_F3_特殊房间"),
            ],
          },
          F4: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("B1B2_F4_楼层"),
              t.runScene.modelEx.getModel("B1B2_F4_TX"),
              t.runScene.modelEx.getModel("B1B2_F4_特殊房间"),
            ],
          },
          F5: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            特殊房间: null,
            content: [
              t.runScene.modelEx.getModel("B1B2_F5_楼层"),
              t.runScene.modelEx.getModel("B1B2_F5_TX"),
              t.runScene.modelEx.getModel("B1B2_F5_特殊房间"),
            ],
          },
          F6: {
            Group: null,
            烟感: null,
            水表: null,
            电表: null,
            室内空气: null,
            网关: null,
            水空调: null,
            监控: null,
            vrv空调: null,
            content: [
              t.runScene.modelEx.getModel("B1B2_F6_楼层"),
              t.runScene.modelEx.getModel("B1B2_F6_TX"),
            ],
          },
        },
        floorBq: [
          t.runScene.modelEx.getModel("B1B2_F1标签"),
          t.runScene.modelEx.getModel("B1B2_F2标签"),
          t.runScene.modelEx.getModel("B1B2_F3标签"),
          t.runScene.modelEx.getModel("B1B2_F4标签"),
          t.runScene.modelEx.getModel("B1B2_F5标签"),
          t.runScene.modelEx.getModel("B1B2_F6标签"),
        ],
        lift: t.runScene.modelEx.getModel("B1B2内容_1"),
        view: {
          cx: -152.12587577627335,
          cy: 63.86517266993396,
          cz: 121.27196485999686,
          tx: 27.06285729490508,
          ty: -18.208086,
          tz: 82.87983735669408,
        },
        chosenFloor: 0,
      },
    };
    this.textureMap = {
      F1: {
        默认: t.map.createMap("./assets/F1_moren.png"),
        点击: t.map.createMap("./assets/F1.png"),
      },
      F2: {
        默认: t.map.createMap("./assets/F2_moren.png"),
        点击: t.map.createMap("./assets/F2.png"),
      },
      F3: {
        默认: t.map.createMap("./assets/F3_moren.png"),
        点击: t.map.createMap("./assets/F3.png"),
      },
      F4: {
        默认: t.map.createMap("./assets/F4_moren.png"),
        点击: t.map.createMap("./assets/F4.png"),
      },
      F5: {
        默认: t.map.createMap("./assets/F5_moren.png"),
        点击: t.map.createMap("./assets/F5.png"),
      },
      F6: {
        默认: t.map.createMap("./assets/F6_moren.png"),
        点击: t.map.createMap("./assets/F6.png"),
      },
    };
    this.pointTextureMap = {
      烟感: {
        待机: t.map.createMap("./assets/shinei_yangan-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_yangan-gaojing-moren.png"),
        正常: t.map.createMap("./assets/shinei_yangan-zhengchang-moren.png"),
        报警: t.map.createMap("./assets/yangan-waring-moren.png"),
      },
      水表: {
        待机: t.map.createMap("./assets/shinei_shuibiao-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_shuibiao-gaojing-moren.png"),
        正常: t.map.createMap("./assets/shinei_shuibiao-zhengchang-moren.png"),
      },
      电表: {
        待机: t.map.createMap("./assets/shinei_dianbiao-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_dianbiao-gaojing-moren.png"),
        正常: t.map.createMap("./assets/shinei_dianbiao-zhengchang-moren.png"),
      },
      室内空气: {
        待机: t.map.createMap("./assets/shinei_kongqizhiliang-daiji-moren.png"),
        告警: t.map.createMap(
          "./assets/shinei_kongqizhiliang-gaojing-moren.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_kongqizhiliang-zhengchang-moren.png"
        ),
      },
      网关: {
        待机: t.map.createMap("./assets/shinei_wangguan-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_wangguan-gaojing-moren.png"),
        正常: t.map.createMap("./assets/shinei_wangguan-zhengchang-moren.png"),
      },
      水空调: {
        待机: t.map.createMap("./assets/shinei_shuikongtiao-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_shuikongtiao-gaojing-moren.png"),
        正常: t.map.createMap(
          "./assets/shinei_shuikongtiao-zhengchang-moren.png"
        ),
      },
      监控: {
        待机: t.map.createMap("./assets/shinei_jishuikong-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_jishuikong-gaojing-moren.png"),
        正常: t.map.createMap(
          "./assets/shinei_jishuikong-zhengchang-moren.png"
        ),
      },
      vrv空调: {
        待机: t.map.createMap("./assets/VRV-daiji-moren.png"),
        告警: t.map.createMap("./assets/VRV-gaojing-moren.png"),
        正常: t.map.createMap("./assets/VRV-zhengchang-moren.png"),
      },
      消防门: {
        待机: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-daiji-moren.png"
        ),
        告警: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-gaojing-moren.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-zhengchang-moren.png"
        ),
      },
    };
    this.clickPointTextureMap = {
      烟感: {
        待机: t.map.createMap("./assets/shinei_yangan-daiji-dianji.png"),
        告警: t.map.createMap("./assets/shinei_yangan-gaojing-dianji.png"),
        正常: t.map.createMap("./assets/shinei_yangan-zhengchang-dianji.png"),
        报警: t.map.createMap("./assets/yangan-waring-dianji.png"),
      },
      水表: {
        待机: t.map.createMap("./assets/shinei_shuibiao-daiji-dianji.png"),
        告警: t.map.createMap("./assets/shinei_shuibiao-gaojing-dianji.png"),
        正常: t.map.createMap("./assets/shinei_shuibiao-zhengchang-dianji.png"),
      },
      电表: {
        待机: t.map.createMap("./assets/shinei_dianbiao-daiji-dianji.png"),
        告警: t.map.createMap("./assets/shinei_dianbiao-gaojing-dianji.png"),
        正常: t.map.createMap("./assets/shinei_dianbiao-zhengchang-dianji.png"),
      },
      室内空气: {
        待机: t.map.createMap(
          "./assets/shinei_kongqizhiliang-daiji-dianji.png"
        ),
        告警: t.map.createMap(
          "./assets/shinei_kongqizhiliang-gaojing-dianji.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_kongqizhiliang-zhengchang-dianji.png"
        ),
      },
      网关: {
        待机: t.map.createMap("./assets/shinei_wangguan-daiji-dianji.png"),
        告警: t.map.createMap("./assets/shinei_wangguan-gaojing-dianji.png"),
        正常: t.map.createMap("./assets/shinei_wangguan-zhengchang-dianji.png"),
      },
      水空调: {
        待机: t.map.createMap("./assets/shinei_shuikongtiao-daiji-dianji.png"),
        告警: t.map.createMap(
          "./assets/shinei_shuikongtiao-gaojing-dianji.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_shuikongtiao-zhengchang-dianji.png"
        ),
      },
      监控: {
        待机: t.map.createMap("./assets/shinei_jishuikong-daiji-dianji.png"),
        告警: t.map.createMap("./assets/shinei_jishuikong-gaojing-dianji.png"),
        正常: t.map.createMap(
          "./assets/shinei_jishuikong-zhengchang-dianji.png"
        ),
      },
      vrv空调: {
        待机: t.map.createMap("./assets/VRV-daiji-dianji.png"),
        告警: t.map.createMap("./assets/VRV-gaojing-dianji.png"),
        正常: t.map.createMap("./assets/VRV-zhengchang-dianji.png"),
      },
    };
    this.hoverPointTextureMap = {
      烟感: {
        待机: t.map.createMap("./assets/shinei_yangan-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/shinei_yangan-gaojing-chupeng.png"),
        正常: t.map.createMap("./assets/shinei_yangan-zhengchang-chupeng.png"),
        报警: t.map.createMap("./assets/yangan-waring-chupeng.png"),
      },
      水表: {
        待机: t.map.createMap("./assets/shinei_shuibiao-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/shinei_shuibiao-gaojing-chupeng.png"),
        正常: t.map.createMap(
          "./assets/shinei_shuibiao-zhengchang-chupeng.png"
        ),
      },
      电表: {
        待机: t.map.createMap("./assets/shinei_dianbiao-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/shinei_dianbiao-gaojing-chupeng.png"),
        正常: t.map.createMap(
          "./assets/shinei_dianbiao-zhengchang-chupeng.png"
        ),
      },
      室内空气: {
        待机: t.map.createMap(
          "./assets/shinei_kongqizhiliang-daiji-chupeng.png"
        ),
        告警: t.map.createMap(
          "./assets/shinei_kongqizhiliang-gaojing-chupeng.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_kongqizhiliang-zhengchang-chupeng.png"
        ),
      },
      网关: {
        待机: t.map.createMap("./assets/shinei_wangguan-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/shinei_wangguan-gaojing-chupeng.png"),
        正常: t.map.createMap(
          "./assets/shinei_wangguan-zhengchang-chupeng.png"
        ),
      },
      水空调: {
        待机: t.map.createMap("./assets/shinei_shuikongtiao-daiji-chupeng.png"),
        告警: t.map.createMap(
          "./assets/shinei_shuikongtiao-gaojing-chupeng.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_shuikongtiao-zhengchang-chupeng.png"
        ),
      },
      监控: {
        待机: t.map.createMap("./assets/shinei_jishuikong-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/shinei_jishuikong-gaojing-chupeng.png"),
        正常: t.map.createMap(
          "./assets/shinei_jishuikong-zhengchang-chupeng.png"
        ),
      },
      vrv空调: {
        待机: t.map.createMap("./assets/VRV-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/VRV-gaojing-chupeng.png"),
        正常: t.map.createMap("./assets/VRV-zhengchang-chupeng.png"),
      },
    };
    Object.keys(this.Builddings).map((buildding) => {
      Object.keys(this.Builddings[buildding].floor).map((floor) => {
        Object.keys(this.Builddings[buildding].floor[floor]).map((op) => {
          if (op != "content") {
            this.Builddings[buildding].floor[floor][
              op
            ] = t.runScene.modelEx.getModel(`${buildding}_${floor}_${op}`);
            if (!this.Builddings[buildding].floor[floor][op]) return;
            this.Builddings[buildding].floor[floor][op].children.map(
              (child) => {
                if (child.material) {
                  child.material = child.material.clone();
                }
              }
            );
          }
        });
      });
    });
    Object.keys(this.Builddings).map((i) => {
      this.builddingContentVisable(i, false);
      this.floorBqVisible(i, false);
      Object.keys(this.Builddings[i].floor).map((op) => {
        this.floorOldPosition[i][op] = this.Builddings[i].floor[
          op
        ].Group.position.y;
        this.floorGoPosition[i][op] =
          this.Builddings[i].floor[op].Group.position.y + this.moveHeight;
      });
    });
    console.log(t.runScene.modelEx.getModel("03-A01-013-DT-16-000003_电梯"));
  }
  setLight(isShow) {
    this.light.forEach((v) => {
      v.visible = isShow;
    });
    // this.light.visible = isShow
  }
  focusBuilding(build, isMySpriteShow = false) {
    if (this.chosenBuilding && this.chosenBuilding != build) {
      this.floorMerge(this.chosenBuilding);
    }
    // controls.enablePan = false;
    if (this.showFloorBq) {
      this.floorBqVisible(build, true);
    }
    t.runScene.modelEx.camAnima(
      t.runScene.modelEx.getCamLocal(),
      this.Builddings[build].view,
      1,
      () => {
        if (isMySpriteShow) {
          t.border.setSpriteMyPosition(t.border.builddingBorder[build], 22);
        }
      }
    );
    bus.emit("emp", false);
    bus.emit("mit", false);
  }
  //返回初始视角
  backToMr(cb, time = 1) {
    bus.emit("backToMr");
    this.hiddenBuildSprite(true);
    controls.enablePan = true;
    this.floorBqVisible(null, false);
    this.floorMerge(this.chosenBuilding);
    this.chosenBuilding = null;
    this.backAnima && this.backAnima.kill();
    this.backAnima = t.runScene.modelEx.camAnima(
      t.runScene.modelEx.getCamLocal(),
      {
        cx: -195.77154991022059,
        cy: 108.86415517224904,
        cz: 336.52840544622154,
        tx: 25.060879026295346,
        ty: -18.208086287267943,
        tz: 64.57891460682868,
      },
      time,
      () => {
        if (bus.emit("getRouter", true) == "/environment") {
          console.log("cnmcnmcnm");
          bus.emit("emp", true);
        }
        cb && cb();
      }
    );
  }
  //外壳显示隐藏
  shell(buildding, isShow = false) {
    Object.values(this.Builddings).map((i) => {
      i.shell.visible = true;
    });
    if (buildding) {
      if (!this.Builddings[buildding]) return;
      this.Builddings[buildding].shell.visible = isShow;
    }
  }
  //建筑标签显示隐藏
  hiddenBuildSprite(isShow) {
    Object.keys(this.Builddings).map((i) => {
      t.border.builddingSpriteVisible(i, isShow);
    });
  }
  //楼层内容显示隐藏
  builddingContentVisable(which, isShow) {
    Object.values(this.Builddings[which].floor).map((i) => {
      i.content.map((op) => {
        if (!op) return;
        op.visible = isShow;
      });
    });
  }
  //楼层标签显示隐藏
  floorBqVisible(which, isShow) {
    if (which) {
      this.Builddings[which].floorBq.map((i) => {
        i.visible = isShow;
      });
    } else {
      Object.values(this.Builddings).map((i) => {
        i.floorBq.map((op) => {
          op.visible = isShow;
        });
      });
    }
  }
  //楼层移动
  floorMove(buildding, floor, dir, cb) {
    // switch (dir) {
    //     case 1:
    //         goY = this.floorGoPosition[buildding][floor]
    //         break;
    //     case 2:
    //         goY = this.floorOldPosition[buildding][floor]
    //     default:
    //         break;
    // }
    Utils.anima(
      {
        y: this.Builddings[buildding].floor[floor].Group.position.y,
      },
      {
        y:
          dir == 1
            ? this.floorGoPosition[buildding][floor]
            : this.floorOldPosition[buildding][floor],
      },
      0.5,
      (data) => {
        this.Builddings[buildding].floor[floor].Group.position.y = data.y;
        t.runScene.modelEx.update(
          this.Builddings[buildding].floor[floor].Group
        );
      },
      () => {
        cb && cb();
      }
    );
  }
  //楼层拆解
  floorDispose(buildding, floor) {
    if (!buildding || !floor) return;
    t.border.builddingSpriteVisible(buildding, false);
    t.border.spriteVisible(false);
    this.chosenBuilding = buildding;
    this.builddingContentVisable(buildding, true);
    let num = parseInt(floor.split("F").pop());
    let chosenFloorTemp = this.Builddings[buildding].chosenFloor;
    let dir = 0;
    if (num !== 6) {
      this.shell(buildding);
    }
    if (chosenFloorTemp == 0) {
      for (let i = num + 1; i <= 6; i++) {
        this.floorMove(buildding, `F${i}`, 1);
      }
    } else {
      if (num > chosenFloorTemp) {
        for (let i = num; i > chosenFloorTemp; i--) {
          this.floorMove(buildding, `F${i}`, 2);
        }
        dir = -1;
      } else {
        for (let i = num + 1; i <= chosenFloorTemp; i++) {
          this.floorMove(buildding, `F${i}`, 1);
        }
      }
    }
    this.Builddings[buildding].floorBq.map((i) => {
      this.floorLabelMap(
        i,
        i.name
          .split("_")
          .pop()
          .split("标签")[0],
        "默认"
      );
    });
    this.Builddings[buildding].chosenFloor = num;
    this.showTypePoint();
    this.queryTimer && clearInterval(this.queryTimer);
    this.queryTimer = setInterval(() => {
      this.showTypePoint();
    }, 30 * 60 * 1000);
    this.showTsRoom(buildding, floor);
    return dir;
    // bus.emit('showFloorPoint', 'smoke', true)
  }
  //楼层合并
  floorMerge(buildding) {
    this.queryTimer && clearInterval(this.queryTimer);
    if (!buildding) return;
    this.controlAllPoint();
    t.border.spriteVisible(false);
    this.showTsRoom();
    Object.keys(this.Builddings[buildding].floor).map((i) => {
      this.floorMove(buildding, i, 2, () => {
        // this.shell();
        if (this.shellVisible) {
          this.shell();
          this.shellVisible = true;
        }
        this.builddingContentVisable(buildding, false);
        if (t.border.isShowBuilddingSprite) {
          t.border.builddingSpriteVisible(buildding, true);
        }
      });
    });
    this.Builddings[buildding].floorBq.map((i) => {
      this.floorLabelMap(
        i,
        i.name
          .split("_")
          .pop()
          .split("标签")[0],
        "默认"
      );
    });
    this.Builddings[buildding].chosenFloor = 0;
  }
  //获得当前的建筑和楼层
  getBuilddingsAndFloor() {
    return {
      buildding: this.chosenBuilding,
      floor: this.chosenBuilding
        ? this.Builddings[this.chosenBuilding].chosenFloor
        : null,
    };
  }
  //烟感显示隐藏
  smokePointVisible(buildding, isShow, floor) {
    Object.values(this.Builddings[buildding].floor).map((i) => {
      if (i["烟感"]) {
        i["烟感"].visible = false;
      }
    });
    if (floor && this.Builddings[buildding].floor[floor]["烟感"]) {
      this.Builddings[buildding].floor[floor]["烟感"].visible = isShow;
    }
  }
  // 水表显示隐藏
  waterPointVisible(buildding, isShow, floor) {
    Object.values(this.Builddings[buildding].floor).map((i) => {
      if (i["水表"]) {
        i["水表"].visible = false;
      }
    });
    if (floor && this.Builddings[buildding].floor[floor]["水表"]) {
      this.Builddings[buildding].floor[floor]["水表"].visible = isShow;
    }
  }
  //电表显示隐藏
  electricPointVisible(buildding, isShow, floor) {
    Object.values(this.Builddings[buildding].floor).map((i) => {
      if (i["电表"]) {
        i["电表"].visible = false;
      }
    });
    if (floor && this.Builddings[buildding].floor[floor]["电表"]) {
      this.Builddings[buildding].floor[floor]["电表"].visible = isShow;
    }
  }
  //控制所有表隐藏
  controlAllPoint() {
    Object.values(this.Builddings[this.chosenBuilding].floor).map((i) => {
      Object.keys(i).map((op) => {
        if (op !== "content" && op !== "Group" && op !== "特殊房间") {
          if (i[op]) {
            i[op].visible = false;
          }
        }
      });
    });
  }
  setTypePoint(type) {
    this.typePoint = type;
  }
  async showTypePoint() {
    let pointStateMap = null;
    await bus
      .emit(
        "getPointState",
        this.buildNoMap[this.chosenBuilding],
        `A0${this.Builddings[this.chosenBuilding].chosenFloor}`
      )
      .then((res) => {
        pointStateMap = JSON.parse(JSON.stringify(res));
      });
    this.controlAllPoint();
    let { buildding, floor } = this.getBuilddingsAndFloor();
    if (this.typePoint === "水空调") {
      if (this.Builddings[buildding].floor[`F${floor}`]["水空调"]) {
        this.Builddings[buildding].floor[`F${floor}`]["水空调"].visible = true;
      }
      if (this.Builddings[buildding].floor[`F${floor}`]["vrv空调"]) {
        this.Builddings[buildding].floor[`F${floor}`]["vrv空调"].visible = true;
      }
    } else {
      if (this.Builddings[buildding].floor[`F${floor}`][this.typePoint]) {
        this.Builddings[buildding].floor[`F${floor}`][
          this.typePoint
        ].visible = true;
      }
    }
    if (!pointStateMap) return;
    pointStateMap.fault = [
      ...pointStateMap.fault,
      ...pointStateMap.beyondAlarm,
    ];
    this.myPointStateMap = JSON.parse(JSON.stringify(pointStateMap));
    this.changePointMap(pointStateMap.normal, "正常", buildding, floor);
    this.changePointMap(pointStateMap.fault, "告警", buildding, floor);
    this.changePointMap(pointStateMap.standby, "待机", buildding, floor);
    this.typePoint === "烟感" &&
      this.changePointMap(pointStateMap.fireAlarm, "报警", buildding, floor);

    this.findModel = null;
    this.hoverPointMap(pointStateMap.normal, "正常", buildding, floor);
    this.hoverPointMap(pointStateMap.fault, "告警", buildding, floor);
    this.hoverPointMap(pointStateMap.standby, "待机", buildding, floor);
    this.typePoint === "烟感" &&
      this.hoverPointMap(pointStateMap.fireAlarm, "报警", buildding, floor);

    if (this.clickFloor && this.myPointStateMap) {
      bus.emit("dialogNumber", this.clickFloor.name);
      t.floor.judge(
        t.floor.myPointStateMap.normal,
        "正常",
        t.floor.clickPointTextureMap,
        t.floor.pointTextureMap,
        this.clickFloor
      );
      t.floor.judge(
        t.floor.myPointStateMap.fault,
        "告警",
        t.floor.clickPointTextureMap,
        t.floor.pointTextureMap,
        this.clickFloor
      );
      t.floor.judge(
        t.floor.myPointStateMap.standby,
        "待机",
        t.floor.clickPointTextureMap,
        t.floor.pointTextureMap,
        this.clickFloor
      );
      this.typePoint === "烟感" &&
        t.floor.judge(
          t.floor.myPointStateMap.fireAlarm,
          "报警",
          t.floor.clickPointTextureMap,
          t.floor.pointTextureMap,
          this.clickFloor
        );

      t.floor.clickPointName = this.clickFloor.name;
      this.clickFloor = null;
      // console.log(this.clickPointName,"this.clickPointName");
    }
  }
  //更换楼层标签贴图
  floorLabelMap(model, floor, flag) {
    t.map.changeMap(model, this.textureMap[floor][flag], "both");
  }
  //电梯显示
  showLift(isShow) {
    this.shellVisible = !isShow;
    Object.keys(this.Builddings).map((i) => {
      this.builddingContentVisable(i, false);
      this.Builddings[i].shell.visible = !isShow;
      this.Builddings[i].lift.visible = isShow;
    });
    // this.liftMove( '03-A01-013-DT-16-000003' ,'静止', 'A1',2)
  }
  //电梯映射
  getLift(num) {
    num.map((i) => {
      this.lift[i.eqpCode] = t.runScene.modelEx.getModel(`${i.eqpCode}_电梯`);
      this.liftKuang[i.eqpCode] = t.runScene.modelEx.getModel(
        `${i.eqpCode}_电梯框`
      );
      this.lift[i.eqpCode].material = this.lift[i.eqpCode].material.clone();
      this.liftKuang[i.eqpCode].material = this.lift[
        i.eqpCode
      ].material.clone();
    });
  }
  //电梯移动
  liftMove(liftNum, state, floor, status) {
    let { r: liftCr, g: liftCg, b: liftCb } = this.liftColor[status].lift;
    let { r: liftKuangCr, g: liftKuangCg, b: liftKuangCb } = this.liftColor[
      status
    ].liftKuang;
    let { r: liftEr, g: liftEg, b: liftEb } = this.liftEmissive[status].lift;
    let { r: liftKuangEr, g: liftKuangEg, b: liftKuangEb } = this.liftEmissive[
      status
    ].liftKuang;
    this.lift[liftNum].material.color = new THREE.Color(
      `rgb(${liftCr},${liftCg},${liftCb})`
    );
    this.lift[liftNum].material.emissive = new THREE.Color(
      `rgb(${liftEr},${liftEg},${liftEb})`
    );
    this.liftKuang[liftNum].material.color = new THREE.Color(
      `rgb(${liftKuangCr},${liftKuangCg},${liftKuangCb})`
    );
    this.liftKuang[liftNum].material.emissive = new THREE.Color(
      `rgb(${liftKuangEr},${liftKuangEg},${liftKuangEb})`
    );
    if (this.lift[liftNum].children[0]) {
      this.lift[liftNum].children[0].material = this.lift[liftNum].material;
    }
    if (floor == "暂无数据") return;
    // if (state == "暂无数据" || floor == "暂无数据") return;
    // this.lift[liftNum].position.y = this.floorLiftPosY[floor];
    // if (state == '静止') return;
    Utils.anima(
      {
        y: this.lift[liftNum].position.y,
      },
      {
        y: this.floorLiftPosY[floor],
      },
      1,
      (data) => {
        this.lift[liftNum].position.y = data.y;
      }
    );
  }
  // 楼层
  async focusFloorPoint(buildding, floor, pointNum) {
    console.log("111111");
    let model = t.runScene.modelEx.getModel(pointNum);
    if (!model) {
      if (this.Builddings[buildding].floor[floor]["室内空气"]) {
        this.Builddings[buildding].floor[floor]["室内空气"].children.map(
          (child) => {
            NameDispose(child.name).map((name) => {
              if (pointNum == name) {
                model = child;
              }
            });
          }
        );
      }
    }
    if (!model) return;
    if (this.chosenBuilding && this.chosenBuilding != buildding) {
      this.floorMerge(this.chosenBuilding);
    }
    this.clickFloor = model;
    let dir = this.floorDispose(buildding, floor);
    let point = t.runScene.modelEx.getWorldLocal(model);
    t.runScene.modelEx.camAnima(
      t.runScene.modelEx.getCamLocal(),
      {
        cx: point.x - 20,
        cy: point.y + dir * this.moveHeight + 10,
        cz: point.z,
        tx: point.x,
        ty: point.y + dir * this.moveHeight,
        tz: point.z,
      },
      0.5,
      () => {
        if (floor == "F6") {
          this.shell();
        } else {
          this.shell(buildding);
        }
      }
    );
  }
  changePointMap(pointMap, state, build, floor) {
    if (this.typePoint == "室内空气") {
      pointMap.map((i) => {
        this.Builddings[build].floor[`F${floor}`]["室内空气"].children.map(
          (child) => {
            NameDispose(child.name).map((name) => {
              if (i == name) {
                t.map.changeMap(
                  child,
                  this.pointTextureMap[this.typePoint][state],
                  "map"
                );
              }
            });
          }
        );
      });
    } else if (this.typePoint == "水空调") {
      pointMap.map((i) => {
        let point = t.runScene.modelEx.getModel(i);
        if (point === undefined) return false;
        if (point.parent.name.indexOf("vrv空调") !== -1) {
          t.map.changeMap(point, this.pointTextureMap["vrv空调"][state], "map");
        } else {
          t.map.changeMap(
            point,
            this.pointTextureMap[this.typePoint][state],
            "map"
          );
        }
      });
    } else {
      pointMap.map((i) => {
        let point = t.runScene.modelEx.getModel(i);
        point &&
          t.map.changeMap(
            point,
            this.pointTextureMap[this.typePoint][state],
            "map"
          );
      });
    }
  }
  hoverPointMap(hoverMap, state, build, floor) {
    if (hoverMap.length === 0) return;
    let hoverModelMap = [];
    if (this.typePoint == "室内空气") {
      hoverMap.map((i) => {
        this.Builddings[build].floor[`F${floor}`]["室内空气"].children.map(
          (child) => {
            NameDispose(child.name).map((name) => {
              if (i == name) {
                let modelMap = t.runScene.modelEx.getModel(child.name);
                if (modelMap === undefined) return false;
                hoverModelMap.push(modelMap);
              }
            });
          }
        );
      });
      hoverModelMap = this.removeDuplicate(hoverModelMap);
    } else {
      hoverMap.map((i) => {
        let modelMap = t.runScene.modelEx.getModel(i);
        if (modelMap === undefined) return false;
        hoverModelMap.push(modelMap);
      });
    }
    // let sb = {};
    // Object.keys(hoverModelMap).map((state) => {
    //   hoverModelMap[state].map(i=>{
    //     sb[i] =
    //     state === "normal"
    //       ? "正常"
    //       : state === "fault"
    //       ? "告警"
    //       : state === "standby"
    //       ? "待机"
    //       : undefined;
    //   })
    // });
    let sb = hoverModelMap.map((i) => i.name);
    if (this.clickPointName != "" && sb.includes(this.clickPointName)) {
      // console.log(this.currentPrice,"currentPrice");
      // console.log(hoverModelMap,this.clickPointName,"this.clickPointName");
      let clickPointModel = t.runScene.modelEx.getModel(this.clickPointName);
      let clickPointModelParent = clickPointModel.parent.name.split("_")[2];
      t.map.changeMap(
        clickPointModel,
        this.clickPointTextureMap[clickPointModelParent][state],
        "map"
      );
    }
    // console.log(hoverModelMap, "hoverModelMap");
    t.runScene.modelEx.getHoverFromModels(hoverModelMap, (models) => {
      if (models) {
        this.findModel = models.find((model) =>
          t.runScene.modelEx.deepIsVisible(model)
        );
        if (!this.findModel) return;
        let parentName = this.findModel.parent.name.split("_")[2];
        hoverModelMap.map((i) => {
          t.map.changeMap(
            i,
            this.pointTextureMap[i.parent.name.split("_")[2]][state],
            "map"
          );
        });
        if (this.clickPointName != "") {
          let clickPointModel = t.runScene.modelEx.getModel(
            this.clickPointName
          );
          let clickPointModelParent = clickPointModel.parent.name.split("_")[2];
          t.map.changeMap(
            clickPointModel,
            this.clickPointTextureMap[clickPointModelParent][
            t.floor.currentPrice
            ],
            "map"
          );
        }
        t.map.changeMap(
          this.findModel,
          this.hoverPointTextureMap[parentName][state],
          "map"
        );
      } else {
        if (!this.findModel) return;
        hoverModelMap.map((i) => {
          t.map.changeMap(
            i,
            this.pointTextureMap[i.parent.name.split("_")[2]][state],
            "map"
          );
          if (i.name == this.clickPointName) {
            t.map.changeMap(
              i,
              this.clickPointTextureMap[i.parent.name.split("_")[2]][state],
              "map"
            );
          }
        });
      }
    });
  }
  judge(stateMap, state, clickMap, pointMap, model) {
    if (stateMap.length === 0) return;
    if (t.floor.typePoint == "室内空气") {
      stateMap.map((i) => {
        NameDispose(model.name).map((name) => {
          if (i == name) {
            if (!model) return;
            t.border.setSpritePosition(model);
            t.map.changeMap(
              model,
              clickMap[model.parent.name.split("_")[2]][state],
              "map"
            );
            t.floor.currentPrice = state;
            return;
          }
        });
      });
    } else {
      stateMap.map((i) => {
        if (i === model.name) {
          const clickModel = t.runScene.modelEx.getModel(
            t.floor.clickPointName
          );
          t.floor.clickPointName &&
            t.map.changeMap(
              clickModel,
              pointMap[clickModel.parent.name.split("_")[2]][
              t.floor.currentPrice
              ],
              "map"
            );
          t.map.changeMap(
            model,
            clickMap[model.parent.name.split("_")[2]][state],
            "map"
          );
          t.floor.currentPrice = state;
        }
      });
    }
  }
  initClick(stateMap, state) {
    if (!stateMap) return;
    if (stateMap.length === 0) return;
    stateMap.map((i) => {
      let model = t.runScene.modelEx.getModel(i);
      if (!model) return;
      t.map.changeMap(
        model,
        t.floor.pointTextureMap[model.parent.name.split("_")[2]][state],
        "map"
      );
    });
  }
  // 去重
  removeDuplicate(arr) {
    return arr.filter((item, index) => {
      return arr.indexOf(item) === index;
    });
  }
  showTsRoom(build, floor) {
    Object.values(this.Builddings).map((build) => {
      Object.values(build.floor).map((floor) => {
        if (floor["特殊房间"]) {
          floor["特殊房间"].visible = false;
        }
      });
    });
    if (!build && !floor) return;
    if (this.Builddings[build].floor[floor]["特殊房间"]) {
      this.Builddings[build].floor[floor]["特殊房间"].visible = true;
    }
  }
}
class Switchover {
  constructor() { }
  sbTextureMap = {}
  init() {
    this.scendScene = {
      SBF: {
        model: t.runScene.modelEx.getModel("SBF"),
        view: {
          cx: -15.143523239510163,
          cy: -493.5071762726372,
          cz: 2.753688754748922,
          tx: -0.11744113424700399,
          ty: -500.3004057463214,
          tz: 0.10418454422260737,
        },
      },
      PDJ_A: {
        model: t.runScene.modelEx.getModel("PDJ_A"),
        view: {
          cx: -13.700645340628508,
          cy: -492.59514779279573,
          cz: 3.334039426402959,
          tx: 0.5741326593714939,
          ty: -499.04871579279575,
          tz: 0.8170104264029601,
        },
      },
      PDJ_D: {
        model: t.runScene.modelEx.getModel("PDJ_D"),
        view: {
          cx: -13.700645340628508,
          cy: -492.59514779279573,
          cz: 3.334039426402959,
          tx: 0.5741326593714939,
          ty: -499.04871579279575,
          tz: 0.8170104264029601,
        },
      },
      XFBF: {
        model: t.runScene.modelEx.getModel("XFBF"),
        view: {
          cx: -13.700645340628508,
          cy: -492.59514779279573,
          cz: 3.334039426402959,
          tx: 0.5741326593714939,
          ty: -499.04871579279575,
          tz: 0.8170104264029601,
        },
      },
      up: {
        view: {
          cx: -195.77154991022059,
          cy: 108.86415517224904,
          cz: 336.52840544622154,
          tx: 25.060879026295346,
          ty: -18.208086287267943,
          tz: 64.57891460682868,
        },
      },
    };
    getAllChildrenModel(this.scendScene["PDJ_A"].model).map((i) => {
      i.material = i.material.clone();
      this.sbTextureMap[i.name] = i.material.clone();
    });
    getAllChildrenModel(this.scendScene["PDJ_D"].model).map((i) => {
      i.material = i.material.clone();
      this.sbTextureMap[i.name] = i.material.clone();
    });
    console.log(this.sbTextureMap, "sbTextureMap");
  }
  boo = document.querySelector(".switchover");
  viewAnima = null;
  scendScene = {};
  isBlack = false;
  closeBoo(cb) {
    bus.emit("switchover", true);
    bus.emit("canClick", false);
    this.isBlack = true;
    return new Promise((s) => {
      Utils.anima(
        {
          opc: 0,
        },
        {
          opc: 1,
        },
        0.3,
        (data) => {
          this.boo.style.opacity = data.opc;
        },
        () => {
          cb && cb();
          s();
        }
      );
    });
  }
  openBoo(cb) {
    return new Promise((s) => {
      Utils.anima(
        {
          opc: 1,
        },
        {
          opc: 0,
        },
        0.3,
        (data) => {
          this.boo.style.opacity = data.opc;
        },
        () => {
          bus.emit("switchover", false);
          cb && cb();
          bus.emit("canClick", true);
          this.isBlack = false;

          s();
        }
      );
    });
  }
  //最大最小视角
  minAndMaxView(min, max) {
    controls.minDistance = min;
    controls.maxDistance = max;
  }
  //相机高度设置
  setContorlsheight(minPai, maxPai, isEnablePan) {
    controls.maxPolarAngle = Math.PI / 2 - maxPai;
    controls.minPolarAngle = isEnablePan ? 0 : Math.PI / 2 - minPai;
    controls.enablePan = isEnablePan;
  }
  //视角转换
  viewTransition(which, cb) {
    this.viewAnima && this.viewAnima.kill();
    return new Promise((s) => {
      this.viewAnima = t.runScene.modelEx.camAnima(
        t.runScene.modelEx.getCamLocal(),
        this.scendScene[which].view,
        0.5,
        () => {
          s();
          cb && cb();
        }
      );
    });
  }
  //显示场景
  showScendScene(which) {
    Object.values(this.scendScene).map((i) => {
      if (i.model) {
        i.model.visible = false;
      }
    });
    if (this.scendScene[which].model) {
      this.scendScene[which].model.visible = true;
    }
  }
  //场景切换
  async changeScene(which, view) {
    await this.closeBoo(() => {
      let { buildding, floor } = t.floor.getBuilddingsAndFloor();
      t.floor.floorMerge(buildding);
      t.floor.floorBqVisible(buildding, false);
      if (which === 'PDJ_A') {
        console.log('PDJ_A');
        getAllChildrenModel(this.scendScene["PDJ_A"].model).map(i => {
          if (this.sbTextureMap[i.name]) {
            i.material.map = this.sbTextureMap[i.name].map
          }
        })
      } else if (which === 'PDJ_D') {
        console.log('PDJ_D');
        getAllChildrenModel(this.scendScene["PDJ_D"].model).map(i => {
          if (this.sbTextureMap[i.name]) {
            i.material.map = this.sbTextureMap[i.name].map
          }
        })
      }
      bus.emit("backToMr");
    });
    this.showScendScene(which);
    if (view) {
      await this.viewTransition(which);
    }
    this.openBoo();
  }
  // async GoDown(which) {
  //         await this.closeBoo();
  //         this.showScendScene(which);
  //         await this.viewTransition(true, which);
  //         await this.openBoo();
  //     }
  // async GoUp() {
  //     await this.closeBoo();
  //     await this.viewTransition(false);
  //     await this.openBoo();
  // }
}
class Parking {
  parkingGroup = null;
  otherGroup = [];
  areaView = {};
  areaMap = {};
  carMap = [];
  dxs = null;
  dxsPoint = null;
  car = null;
  cloneCarMap = [];
  pointMap = null;
  isPraking = false;
  clickArea = null;
  parkingFlag = null;
  routerToParking = {
    "/waterCons": "水表",
    "/eleCons": "电表",
    "/firecontrol/0": "烟感",
    "/gateway": "网关",
    "/monitoring": "监控",
    "/environment": "室内空气",
  };
  undergroundAlldata = null;
  pipeline = null;
  underClick = null;
  queryUnderTimer = null;
  init() {
    allGroup.map((i, index) => {
      this.otherGroup[index] = t.runScene.modelEx.getModel(i);
    });
    this.parkingGroup = t.runScene.modelEx.getModel("地下区域组");
    this.areaView = {
      人防: {
        cx: -114.03219991164794,
        cy: 133.62119289200726,
        cz: 193.26757323259145,
        tx: 18.225500938907498,
        ty: -18.208086,
        tz: 191.13863942349084,
      },
      D: {
        cx: -113.1719973529177,
        cy: 122.31389116964354,
        cz: 137.31485874878805,
        tx: 16.629758533656616,
        ty: -18.208086,
        tz: 136.73594653964642,
      },
      C: {
        cx: -101.02019660624367,
        cy: 131.02618979060827,
        cz: 57.403596262327554,
        tx: 18.663149753661653,
        ty: -18.208086,
        tz: 56.86981181905156,
      },
      B: {
        cx: -89.17611915025995,
        cy: 147.35694037339738,
        cz: -35.18432387075124,
        tx: 6.653399214899863,
        ty: -18.208086,
        tz: -35.61172054857074,
      },
      A: {
        cx: -97.46891673258317,
        cy: 136.43294614880352,
        cz: -159.9296663216958,
        tx: 15.141723174461346,
        ty: -18.208086,
        tz: -160.43190689304703,
      },
      初始: {
        cx: -194.18568374644178,
        cy: 108.86415500000001,
        cz: 337.8085465064873,
        tx: 25.060879,
        ty: -18.208086,
        tz: 64.578915,
      },
    };
    this.areaMap = {
      A: {
        model: t.runScene.modelEx.getModel("A区组"),
        bq: t.runScene.modelEx.getModel("Az"),
        flag: "A",
      },
      B: {
        model: t.runScene.modelEx.getModel("B区组"),
        bq: t.runScene.modelEx.getModel("Bz"),
        flag: "B",
      },
      C: {
        model: t.runScene.modelEx.getModel("C区组"),
        bq: t.runScene.modelEx.getModel("Cz"),
        flag: "C",
      },
      D: {
        model: t.runScene.modelEx.getModel("D区组"),
        bq: t.runScene.modelEx.getModel("Dz"),
        flag: "D",
      },
      E: {
        model: t.runScene.modelEx.getModel("E区组"),
        bq: t.runScene.modelEx.getModel("人防z"),
        flag: "E",
      },
    };
    this.car = t.runScene.modelEx.getModel("车001");
    this.dxs = t.runScene.modelEx.getModel("地下区域组");
    this.dxsPoint = t.runScene.modelEx.getModel("地下室组");
    this.pipeline = t.runScene.modelEx.getModel("外场管线");
    this.pipeline.visible = false;
    // this.dxsPoint.visible = false;
    this.pointMap = {
      烟感: {
        area: null,
        group: [t.runScene.modelEx.getModel("地下室-烟感")],
        bq: "all",
      },
      水表: {
        area: this.areaMap["A"].model,
        group: [t.runScene.modelEx.getModel("地下室-水表")],
        bq: this.areaMap["A"].bq,
      },
      电表: {
        area: null,
        group: [t.runScene.modelEx.getModel("地下室-电表")],
        bq: "all",
      },
      网关: {
        area: this.areaMap["A"].model,
        group: [t.runScene.modelEx.getModel("地下室-网关")],
        bq: this.areaMap["A"].bq,
      },
      监控: {
        area: null,
        group: [t.runScene.modelEx.getModel("地下室-监控")],
        bq: "all",
      },
      室内空气: {
        area: null,
        group: [
          t.runScene.modelEx.getModel("地下室-空气检测"),
          t.runScene.modelEx.getModel("地下室-集水井"),
        ],
        bq: "all",
      },
      消防门: {
        group: [t.runScene.modelEx.getModel("地下室-消防门")],
      },
    };
    this.car.visible = false;
    this.parkingFlag = t.runScene.modelEx.getModel("停车场牌子组");
    this.parkingFlag.visible = false;
    //克隆材质
    getAllChildrenModel(this.dxs).map((i) => {
      if (i.material) {
        i.material = i.material.clone();
        i.material.transparent = true;
      }
    });
  }
  showParkingFlag(route) {
    if (this.routerToParking[route]) {
      this.parkingFlag.visible = true;
    } else {
      this.parkingFlag.visible = false;
    }
  }
  goToParking(go) {
    this.parkingGroup.visible = go;
    this.otherGroup.map((i) => {
      i.visible = !go;
    });
    t.border.builddingSpriteVisible("all", !go);
  }
  focusArea(area, cb) {
    t.runScene.modelEx.camAnima(
      t.runScene.modelEx.getCamLocal(),
      this.areaView[area],
      1,
      () => {
        cb && cb();
      }
    );
  }
  getCarNum(num) {
    this.carMap = [];
    this.carMap = num.map((i) => i);
    let carNameMap = this.cloneCarMap.map((car) => car.name.split("Car")[1]);
    let isDif =
      carNameMap.every((i) => this.carMap.includes(i)) &&
      this.carMap.every((i) => carNameMap.includes(i));
    console.log(isDif, bus.emit("getRouter", true) === "/park", "oo");
    if (!isDif && bus.emit("getRouter", true) === "/park") {
      console.log("carcarcar");
      this.carMap = [];
      this.carMap = num.map((i) => i);
      this.removeCar();
      this.createCar();
    }
  }
  createCar() {
    this.carMap.map((i) => {
      let cloneCar = t.runScene.modelEx.clone(this.car);
      let point = t.runScene.modelEx.getModel(i);
      if (point == undefined) {
        point = t.runScene.modelEx.getModel(`Bq${i}`);
      }
      if (point) {
        let { x, y, z } = t.runScene.modelEx.getWorldLocal(point);
        cloneCar.position.set(x, y, z);
        cloneCar.scale.set(100, 100, 100);
        cloneCar.visible = true;
        cloneCar.name = `Car${i}`;
        cloneCar.rotation.z = point.rotation.z;
        this.cloneCarMap.push(cloneCar);
        t.runScene.modelEx.add(cloneCar);
      }
    });
  }
  removeCar() {
    this.cloneCarMap.map((i) => {
      t.runScene.modelEx.remove(i);
    });
    this.cloneCarMap = [];
  }
  async sbParking(isShow, cb) {
    let tR = bus.emit("getRouter");
    if (isShow) {
      console.log(isShow, "isShow");
      this.queryUnderground();
      this.queryUnderTimer && clearInterval(this.queryUnderTimer);
      this.queryUnderTimer = setInterval(() => {
        this.queryUnderground();
      }, 30 * 60 * 1000);
    } else {
      console.log(isShow, "isShow");
      this.queryUnderTimer && clearInterval(this.queryUnderTimer);
    }
    if (this.routerToParking[tR]) {
      await t.switchover.closeBoo();
      this.setParkingThing(tR);
      this.pipeline.visible = false;
      this.isPraking = isShow;
      if (this.routerToParking[tR] == "监控") {
        t.border.showMit(!isShow);
      }
      if (this.routerToParking[tR] == "室内空气") {
        let timer = setTimeout(() => {
          t.border.showEmp(!isShow);
          clearTimeout(timer);
        }, 500);
      }
      if (
        this.routerToParking[tR] == "水表" ||
        this.routerToParking[tR] == "电表"
      ) {
        bus.emit("getClickBuild", "A区地下室");
      }
      t.floor.backToMr(() => {
        this.goToParking(isShow);
        cb && cb();
        t.switchover.openBoo();
      }, 0.5);
    }
  }
  clearTimer() {
    this.queryUnderTimer && clearInterval(this.queryUnderTimer);
  }
  quitParking(cb) {
    this.goToParking(false);
    this.parkingToMr();
    cb && cb();
  }
  setParkingThing(router) {
    let Area = this.pointMap[this.routerToParking[router]];
    this.parkingToMr();
    this.pointVisible(false);
    if (this.routerToParking[router] === "烟感") {
      this.pointMap["消防门"].group.map((i) => {
        i.visible = true;
      });
    }
    Area.group.map((i) => {
      i.visible = true;
    });
    this.clickArea = Area.bq;
    if (Area.area) {
      Object.values(this.areaMap).map((i) => {
        getAllChildrenModel(i.model).map((op) => {
          op.material.opacity = 0.3;
        });
        i.bq.material.opacity = 0.3;
      });
      getAllChildrenModel(Area.area).map((i) => {
        i.material.opacity = 1;
      });
      Area.bq.material.opacity = 1;
    }
  }
  parkingToMr() {
    getAllChildrenModel(this.dxs).map((i) => {
      i.material.opacity = 1;
    });
    Object.values(this.areaMap).map((i) => {
      i.bq.material.opacity = 1;
    });
    this.pointVisible(true);
    this.clickArea = null;
    this.isPraking = false;
  }
  pointVisible(isShow) {
    Object.values(this.pointMap).map((i) => {
      i.group.map((op) => {
        op.visible = isShow;
      });
    });
  }
  // 地下
  async focusParingPoint(num) {
    let model = t.runScene.modelEx.getModel(num);
    if (!model) return;
    let point = t.runScene.modelEx.getWorldLocal(model);
    if (!this.isPraking) {
      this.sbParking(true, () => {
        t.runScene.modelEx.camAnima(
          t.runScene.modelEx.getCamLocal(),
          {
            cx: point.x - 20,
            cy: point.y + 20,
            cz: point.z,
            tx: point.x,
            ty: point.y,
            tz: point.z,
          },
          0.5,
          () => {
            if (this.undergroundAlldata) {
              t.ponintstate.allPointMap(model, this.undergroundAlldata);
            }
          }
        );
      });
    } else {
      t.runScene.modelEx.camAnima(
        t.runScene.modelEx.getCamLocal(),
        {
          cx: point.x - 20,
          cy: point.y + 20,
          cz: point.z,
          tx: point.x,
          ty: point.y,
          tz: point.z,
        },
        0.5,
        () => {
          if (this.undergroundAlldata) {
            t.ponintstate.allPointMap(model, this.undergroundAlldata);
          }
        }
      );
    }
  }
  changeParkingPointMap(pointMap, state) {
    console.log(pointMap, state);
    // getAllChildrenModel(t.switchover.scendScene["PDJ_A"].model).map((i) => {
    //   i.name = i.name + "No";
    // });
    // getAllChildrenModel(t.switchover.scendScene["PDJ_D"].model).map((i) => {
    //   i.name = i.name + "No";
    // });
    if (!pointMap) return;
    pointMap.map((i) => {
      let point = t.runScene.modelEx.getModel(i);
      if (!point) return;
      if (point) {
        console.log(this.routerToParking[bus.emit("getRouter")], "cnm");
        if (this.routerToParking[bus.emit("getRouter")] === "烟感") {
          t.map.changeMap(
            point,
            t.floor.pointTextureMap[
            this.routerToParking[bus.emit("getRouter")]
            ][state],
            "map"
          );
          if (point.parent.name === "地下室-消防门") {
            t.map.changeMap(
              point,
              t.floor.pointTextureMap["消防门"][state],
              "map"
            );
          }
        } else if (this.routerToParking[bus.emit("getRouter")] === "室内空气") {
          t.map.changeMap(
            point,
            t.floor.pointTextureMap[
            this.routerToParking[bus.emit("getRouter")]
            ][state],
            "map"
          );
          if (point.parent.name === "地下室-集水井") {
            t.map.changeMap(
              point,
              t.ponintstate.undergroundPointTextureMap[point.parent.name][
              state
              ],
              "map"
            );
          }
        } else {
          t.map.changeMap(
            point,
            t.floor.pointTextureMap[
            this.routerToParking[bus.emit("getRouter")]
            ][state],
            "map"
          );
        }
      }
    });
    // getAllChildrenModel(t.switchover.scendScene["PDJ_A"].model).map((i) => {
    //   i.name = i.name.split("No")[0];
    // });
    // getAllChildrenModel(t.switchover.scendScene["PDJ_D"].model).map((i) => {
    //   i.name = i.name.split("No")[0];
    // });
  }

  //地下点位轮询
  async queryUnderground() {
    let pointMap = [];
    await bus.emit("getPointState", "08", "B01").then((res) => {
      pointMap = JSON.parse(JSON.stringify(res));
    });
    // pointMap = JSON.parse(JSON.stringify(res));
    if (!pointMap) return;
    pointMap.fault = [...pointMap.fault, ...pointMap.beyondAlarm];
    console.log(pointMap, "pointMap");
    this.undergroundAlldata = JSON.parse(JSON.stringify(pointMap));
    this.changeParkingPointMap(pointMap.normal, "正常");
    this.changeParkingPointMap(pointMap.fault, "告警");
    this.changeParkingPointMap(pointMap.standby, "待机");
    this.routerToParking[bus.emit("getRouter")] === "烟感" &&
      this.changeParkingPointMap(pointMap.fireAlarm, "报警");

    // this.changeParkingPointMap(pointMap.standby, "待机");

    // 地下Hover事件
    t.ponintstate.undergroundHoverPointMap(pointMap.normal, "正常");
    t.ponintstate.undergroundHoverPointMap(pointMap.fault, "告警");
    t.ponintstate.undergroundHoverPointMap(pointMap.standby, "待机");
    this.routerToParking[bus.emit("getRouter")] === "烟感" &&
      t.ponintstate.undergroundHoverPointMap(pointMap.fireAlarm, "报警");
  }
}
class Border {
  constructor() { }
  builddingBorder = {};
  builddingSpriteMap = {};
  empSprite = {};
  sprite = null;
  emp = null;
  mit = null;
  mySprite = null;
  isShowBuilddingSprite = true;
  init() {
    this.builddingBorder = {
      B3: t.runScene.modelEx.getModel("B3看牌"),
      A1: t.runScene.modelEx.getModel("A1看牌"),
      A2: t.runScene.modelEx.getModel("A2看牌"),
      B1B2: t.runScene.modelEx.getModel("B1B2看牌"),
    };
    this.emp = t.runScene.modelEx.getModel("环境监测点位");
    this.mit = t.runScene.modelEx.getModel("外场监控");
    this.emp.visible = false;
    Object.values(this.builddingBorder).map((i) => {
      i.visible = false;
    });
    this.domToBuilddingSprite();
    // this.domToMySprite("tieTu");
  }
  domToBuilddingSprite() {
    Object.keys(this.builddingBorder).map((i) => {
      let dom = document.querySelector(`.${i}`);
      let timer = setTimeout(() => {
        dom.style.opacity = 1;
        clearTimeout(timer);
      }, 100);
      let sprite = Utils.domTo2Dui(dom);
      sprite.visible = true;
      this.builddingBorder[i].add(sprite);
      this.builddingSpriteMap[i] = sprite;
    });
  }
  builddingSpriteVisible(buildding, isShow) {
    if (buildding == "all") {
      Object.values(this.builddingSpriteMap).map((i) => {
        i.visible = isShow;
      });
    } else {
      if (this.builddingSpriteMap[buildding]) {
        this.builddingSpriteMap[buildding].visible = isShow;
      }
    }
  }
  //环境监测点位
  domToEmp() {
    this.emp.children.map((i) => {
      let dom = document.createElement("div");
      dom.classList.add("hjjc", i.name);
      document.body.appendChild(dom);
      dom.onmousedown = () => {
        this.setSpritePosition(i);
        bus.emit("empNumber", dom.className.split("hjjc ").pop());
      };
      this.empSprite[i.name] = Utils.domTo2Dui(dom);
      this.empSprite[i.name].visible = false;
      i.add(this.empSprite[i.name]);
    });
  }
  //显示环境监测点位
  showEmp(isShow) {
    this.emp.visible = isShow;
  }
  showMit(isShow) {
    this.mit.visible = isShow;
  }
  //生成弹框
  domToSprite(className) {
    let dom = document.querySelector(`.${className}`);
    const fn = (e) => {
      // e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    };
    dom.addEventListener("pointerdown", fn);
    dom.addEventListener("pointerup", fn);
    this.sprite = Utils.domTo2Dui(dom);
    this.sprite.visible = false;
    t.runScene.modelEx.add(this.sprite);
    // let dom = document.querySelector(`.${className}`);
    // this.sprite = Utils.domTo2Dui(dom);
    // this.sprite.visible = false;
    // t.runScene.modelEx.add(this.sprite);
  }
  //移除弹框
  removeSprite() {
    this.sprite && t.runScene.modelEx.remove(this.sprite);
  }
  //设置弹框位置
  setSpritePosition(model) {
    if (this.sprite) {
      this.sprite.visible = true;
      let { x, y, z } = t.runScene.modelEx.getWorldLocal(model);
      this.sprite.position.set(x, y, z);
    }
  }
  domToMySprite(className) {
    let dom = document.querySelector(`.${className}`);
    let timer = setTimeout(() => {
      dom.classList.add("show");
      clearTimeout(timer);
    }, 100);
    this.mySprite = Utils.domTo2Dui(dom);
    this.mySprite.visible = false;
    t.runScene.modelEx.add(this.mySprite);
  }
  setSpriteMyPosition(model, pos) {
    if (this.mySprite) {
      this.mySprite.visible = true;
      let { x, y, z } = t.runScene.modelEx.getWorldLocal(model);
      this.mySprite.position.set(x, y, z + pos);
    }
  }
  //弹框显示隐藏
  spriteMyVisible(isShow) {
    if (this.mySprite) {
      this.mySprite.visible = isShow;
    }
  }
  //弹框显示隐藏
  spriteVisible(isShow) {
    if (this.sprite) {
      this.sprite.visible = isShow;
    }
  }
}
class Map {
  f5 = null;
  init() {
    //   this.f5 = t.runScene.modelEx.getModel('F5');
    //   console.log(this.f5, 'this.f5');
    //   let texture = this.createMap('./assets/bg1.png');
    // this.changeMap(this.f5, texture, 'emissiveMap');
    // this.changeMap(this.f5, texture, 'map');
    // this.changeMap(this.f5, texture, 'both')
  }
  // 创建map
  createMap(url) {
    let textureLoader = new THREE.TextureLoader();
    let map = textureLoader.load(url, (texture) => {
      return texture;
    });
    return map;
  }
  /**
   *
   * @param {*} model
   * @param {*} texture
   * @param {*} which
   */
  changeMap(model, texture, which) {
    if (which === "both") {
      model.material.emissiveMap = texture; //法线贴图
      model.material.map = texture; //法线贴图
    } else {
      model.material[which] = texture; //法线贴图
    }
    model.material.normalScale = new THREE.Vector2(3, -3);
    model.material.roughness = 0.4;
    model.material.needsUpdate = true;
  }
}
class Shuipump {
  sbf = {
    pump1Running: {
      model: null,
      运行: t.map.createMap("./assets/yunxing.png"),
      待机: t.map.createMap("./assets/daiji.png"),
    },
    pump2Running: {
      model: null,
      运行: t.map.createMap("./assets/yunxing.png"),
      待机: t.map.createMap("./assets/daiji.png"),
    },
    pump3Running: {
      model: null,
      运行: t.map.createMap("./assets/yunxing.png"),
      待机: t.map.createMap("./assets/daiji.png"),
    },
    pump4Running: {
      model: null,
      运行: t.map.createMap("./assets/yunxing.png"),
      待机: t.map.createMap("./assets/daiji.png"),
    },
  };
  sprite = null;
  liquid = {
    Yewei: t.runScene.modelEx.getModel("Yewei"),
    当前液位显示: t.runScene.modelEx.getModel("当前液位显示"),
    液位显示: t.runScene.modelEx.getModel("液位显示"),
  };
  stateArray = null;
  psSprite = null;
  sbfName = {
    pump1Running: "SBF_泵1",
    pump2Running: "SBF_泵2",
    pump3Running: "SBF_泵3",
    pump4Running: "SBF_泵4",
  };
  sbfPonit = {
    SBF_泵1: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-moren.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-moren.png"),
    },
    SBF_泵2: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-moren.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-moren.png"),
    },
    SBF_泵3: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-moren.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-moren.png"),
    },
    SBF_泵4: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-moren.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-moren.png"),
    },
  };
  clickSbfPoint = {
    SBF_泵1: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-dianji.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-dianji.png"),
    },
    SBF_泵2: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-dianji.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-dianji.png"),
    },
    SBF_泵3: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-dianji.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-dianji.png"),
    },
    SBF_泵4: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-dianji.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-dianji.png"),
    },
  };
  hoverSbfPoint = {
    SBF_泵1: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-chupeng.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-chupeng.png"),
    },
    SBF_泵2: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-chupeng.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-chupeng.png"),
    },
    SBF_泵3: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-chupeng.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-chupeng.png"),
    },
    SBF_泵4: {
      运行: t.map.createMap("./assets/shinei_shuibeng-zhengchang-chupeng.png"),
      待机: t.map.createMap("./assets/shinei_shuibeng-daiji-chupeng.png"),
    },
  };
  clickPointName = "";
  sbfName1 = {
    pump1Running: "zhuangtai1",
    pump2Running: "zhuangtai2",
    pump3Running: "zhuangtai3",
    pump4Running: "zhuangtai4",
  };
  zhuagTai = {
    zhuangtai1: null,
    zhuangtai2: null,
    zhuangtai3: null,
    zhuangtai4: null,
  };
  init() {
    this.sbfMap();
    this.zhuangTaiMap();
    // this.psToSprite();
    // this.changeFloorBqMap("pump1Running", "运行")
    // this.changeFloorBqMap("pump2Running", "运行")
    // this.changeFloorBqMap("pump3Running", "运行")
    // this.changeFloorBqMap("pump4Running", "运行")
    // this.liquidLevel(4,1.31)
  }
  zhuangTaiMap() {
    Object.keys(this.zhuagTai).map((v) => {
      this.zhuagTai[v] = t.runScene.modelEx.getModel(v);
    });
  }
  sbfMap() {
    Object.keys(this.sbf).map((v, i) => {
      this.sbf[v]["model"] = t.runScene.modelEx.getModel(`SBF_泵${i + 1}`);
      this.sbf[v]["model"].material = this.sbf[v]["model"].material.clone();
    });
  }
  changeFloorBqMap(pump, state) {
    t.map.changeMap(this.sbf[pump]["model"], this.sbf[pump][state], "both");
  }
  changeFloorBqXh(pumpArray) {
    if (!pumpArray) return;
    this.stateArray = pumpArray;
    t.shuipump.changePointMap(pumpArray);
    this.hoverSbfPointMap(pumpArray);
  }

  changePointMap(pointMap) {
    if (!pointMap) return;
    pointMap.map((i) => {
      this.zhuagTai[this.sbfName1[i.name]].visible =
        i.status == "运行" ? true : false;
      let point = t.runScene.modelEx.getModel(this.sbfName[i.name]);
      if (!point) return;
      point &&
        t.map.changeMap(
          point,
          this.sbfPonit[this.sbfName[i.name]][i.status],
          "map"
        );
    });
  }

  hoverSbfPointMap(hoverMap) {
    if (hoverMap.length === 0) return;
    let hoverModelMap = [];
    hoverMap.map((i) => {
      let modelMap = t.runScene.modelEx.getModel(this.sbfName[i.name]);
      if (modelMap === undefined) return false;
      hoverModelMap.push(modelMap);
    });
    t.runScene.modelEx.getHoverFromModels(hoverModelMap, (models) => {
      if (models) {
        this.findModel = models.find((model) =>
          t.runScene.modelEx.deepIsVisible(model)
        );
        if (!this.findModel) return;
        hoverMap.map((v) => {
          let model = t.runScene.modelEx.getModel(this.sbfName[v.name]);
          t.map.changeMap(
            model,
            this.sbfPonit[this.sbfName[v.name]][v.status],
            "map"
          );
        });
        if (this.clickPointName != "") {
          let clickPointModel = t.runScene.modelEx.getModel(
            this.clickPointName
          );
          hoverMap.map((v) => {
            if (this.sbfName[v.name] === clickPointModel.name) {
              t.map.changeMap(
                clickPointModel,
                this.clickSbfPoint[clickPointModel.name][v.status],
                "map"
              );
            }
          });
        }
        hoverMap.map((v) => {
          if (this.findModel.name === this.sbfName[v.name]) {
            t.map.changeMap(
              this.findModel,
              this.hoverSbfPoint[this.findModel.name][v.status],
              "map"
            );
          }
        });
      } else {
        if (!this.findModel) return;
        hoverMap.map((v) => {
          let model = t.runScene.modelEx.getModel(this.sbfName[v.name]);
          t.map.changeMap(
            model,
            this.sbfPonit[this.sbfName[v.name]][v.status],
            "map"
          );
          if (this.sbfName[v.name] == this.clickPointName) {
            let clickPointModel = t.runScene.modelEx.getModel(
              this.clickPointName
            );
            t.map.changeMap(
              clickPointModel,
              this.clickSbfPoint[clickPointModel.name][v.status],
              "map"
            );
          }
        });
      }
    });
  }

  clickPoint(stateMap, clickMap, pointMap, model) {
    stateMap.map((i) => {
      const clickModel = t.runScene.modelEx.getModel(t.shuipump.clickPointName);
      if (t.shuipump.clickPointName) {
        if (this.sbfName[i.name] === clickModel.name) {
          t.map.changeMap(
            clickModel,
            pointMap[t.shuipump.clickPointName][i.status],
            "map"
          );
        }
      }
      if (this.sbfName[i.name] === model.name) {
        t.map.changeMap(model, clickMap[model.name][i.status], "map");
      }
    });
  }
  //生成弹框
  psToSprite() {
    let dom = document.querySelector(".psDom");
    let timer = setTimeout(() => {
      dom.classList.add("show");
      clearTimeout(timer);
    }, 100);
    this.psSprite = Utils.domTo3DSprite(dom);
    this.psSprite.visible = false;
    t.runScene.modelEx.add(this.psSprite);
  }
  //设置弹框位置
  setpsSpritePosition(model) {
    if (this.psSprite) {
      this.psSprite.visible = true;
      let { x, y, z } = t.runScene.modelEx.getWorldLocal(model);
      this.psSprite.position.set(x, y + 1, z);
      this.psSprite.scale.set(0.01, 0.01, 0.01);
      // this.stateArray.forEach((v, i) => {
      //     if (model.name !== this.sbf[v.name].model.name) return false;
      //     this.psSprite.element.innerText = `设备名称：${this.sbfName[v.name]}设备状态：${v.status}`;
      // });
    }
  }
  //弹框显示隐藏
  psSpriteVisible(isShow) {
    if (this.psSprite) {
      this.psSprite.visible = isShow;
    }
  }
  liquidLevel(zong, dang) {
    let high = dang / zong;
    this.liquid["当前液位显示"].visible = false;
    this.liquid["Yewei"].scale.set(1, high, 1);
    let { x, z } = this.liquid["液位显示"].position;
    let y;
    if (high * 10 >= 5) {
      y = 0.2460097615440947 * (high * 10 + 2.98);
    } else {
      y = 0.2460097615440947 * (high * 10 + 3.24);
    }
    this.liquid["液位显示"].position.set(x, y, z);
    this.toSprite();
    this.setYwSpritePosition(this.liquid["液位显示"], high, dang);
  }
  toSprite() {
    let dom = document.querySelector(".flow");
    let timer = setTimeout(() => {
      dom.classList.add("show");
      clearTimeout(timer);
    }, 100);
    this.sprite = Utils.domTo3DSprite(dom);
    t.runScene.modelEx.add(this.sprite);
    this.sprite.visible = false;
  }
  setYwSpritePosition(model, high, dang) {
    high = (high * 100).toFixed(2);
    let { x, y, z } = t.runScene.modelEx.getWorldLocal(model);
    this.sprite.position.set(x, y, z + 1.2);
    this.sprite.scale.set(0.025 / 2, 0.025 / 2, 0.025 / 2);
    this.sprite.element.innerHTML = `液位:${dang}米</br>占比:${high}%`;
    let timer = setTimeout(() => {
      this.sprite.visible = true;
      clearTimeout(timer);
    }, 100);
  }
  removeSprite(sprite) {
    console.log("pppppppp");
    sprite.visible = false;
  }
}
class Pdjevent {
  pdjA = {
    A_part_B: {
      pos: {
        cx: -4.167334714638805,
        cy: -498.08000152825,
        cz: -2.8458880586506488,
        tx: 2.394763855804363,
        ty: -499.048716,
        tz: -2.9604299152630915,
      },
      model: t.runScene.modelEx.getModel("A_part_B"),
    },
    A_part_A: {
      pos: {
        cx: -5.848570689514851,
        cy: -497.03230986235724,
        cz: 5.2926593043730445,
        tx: 2.04282,
        ty: -499.048716,
        tz: 5.246748,
      },
      model: t.runScene.modelEx.getModel("A_part_A"),
    },
  };
  pdjA1 = {
    A_part_GuiZi: t.runScene.modelEx.getModel("A_part_GuiZi"),
    A_part_G: t.runScene.modelEx.getModel("A_part_G"),
  };
  pdjD = {
    D_part_A: {
      pos: {
        cx: -8.362663915884854,
        cy: -497.8348738476574,
        cz: 0.2117135082073759,
        tx: 0.5748861771082417,
        ty: -499.048716,
        tz: -0.10039314733764977,
      },
      model: t.runScene.modelEx.getModel("D_part_A"),
    },
    D_part_B: {
      pos: {
        cx: 2.7403348497021467,
        cy: -497.5235075427436,
        cz: -4.535287803386308,
        tx: 2.6885854261569873,
        ty: -499.048716,
        tz: 4.359749856160508,
      },
      model: t.runScene.modelEx.getModel("D_part_B"),
    },
  };
  pdjD1 = {
    D_part_GuiZi: t.runScene.modelEx.getModel("D_part_GuiZi"),
    D_part_G: t.runScene.modelEx.getModel("D_part_G"),
  };
  floor = {
    A_Floor: t.runScene.modelEx.getModel("A_Floor"),
    D_floor: t.runScene.modelEx.getModel("D_floor"),
  };
  isState;
  back = document.querySelectorAll(".backA");
  pdjMap = {
    PDJ_A: t.runScene.modelEx.getModel("PDJ_A"),
    PDJ_D: t.runScene.modelEx.getModel("PDJ_D"),
  };
  clickMethod = true;
  clickModel = false;
  init() { }
  isFixed(boolean) {
    //是否可以缩放
    controls.enableZoom = boolean;
    //是否开启右键拖拽
    controls.enabled = boolean;
  }
  setPdjA(parent, parent1, model, localo) {
    Object.keys(parent).map((v) => {
      parent[v]["model"].visible = false;
    });
    Object.keys(parent1).map((v) => {
      parent1[v].visible = false;
    });
    parent[model]["model"].visible = true;
    if (this.clickMethod) {
      t.runScene.modelEx.camAnima(
        t.runScene.modelEx.getCamLocal(),
        parent[model]["pos"],
        1
      );
    } else {
      this.searchView(localo);
    }
    let modelA = model.slice(0, 1);
    if (modelA === "D") {
      t.map.changeMap(this.floor[`D_floor`], null, "both");
      this.back[0].style.display = "none";
      this.back[1].style.display = "block";
    } else {
      t.map.changeMap(this.floor[`${modelA}_Floor`], null, "both");
      this.back[1].style.display = "none";
      this.back[0].style.display = "block";
    }
    // this.stopMove()
    // this.isFixed(false)
    // t.switchover.minAndMaxView(3, 10);
    // controls.maxPolarAngle = Math.PI / 2 - 0.1;
    // 阻止场景下沉
    controls.screenSpacePanning = false;
    this.isState = true;
  }
  conceal(pdj, pdjOne) {
    Object.keys(pdj).map((v) => {
      pdj[v]["model"].visible = true;
    });
    Object.keys(pdjOne).map((v) => {
      pdjOne[v].visible = true;
    });
  }
  resetCamAnima() {
    t.runScene.modelEx.camAnima(
      t.runScene.modelEx.getCamLocal(),
      {
        cx: -13.700645000000002,
        cy: -492.595148,
        cz: 3.334038999999999,
        tx: 0.574133,
        ty: -499.048716,
        tz: 0.81701,
      },
      0.57
    );
  }
  reset() {
    t.switchover.minAndMaxView(0, 400);
    controls.maxPolarAngle = Math.PI / 2 - 0.1;
    controls.screenSpacePanning = true;
    // this.isFixed(true)
    this.isState = false;
  }
  backPdj(isPdj, isExecute = true) {
    this.back[isPdj === "pdjA" ? 0 : 1].style.display = "none";
    this.conceal(
      isPdj === "pdjA" ? this.pdjA : this.pdjD,
      isPdj === "pdjA" ? this.pdjA1 : this.pdjD1
    );
    this.reset();
    if (isExecute) {
      this.resetCamAnima();
    }
  }
  stopMove = () => {
    let cameraPosition = camera.position;
    let dis = cameraPosition.distanceTo({
      x: -233.09073047114157,
      y: -31.745605409145355,
      z: -260.3802162347133,
    });
    if (dis >= 575) {
      controls.enablePan = false;
      // 1.5秒后恢复
      Utils.getMacro(() => {
        // 重新恢复至初始视角动静
        // t.entranceAmin();
        t.runScene.modelEx.camAnima(
          t.runScene.modelEx.getCamLocal(),
          {
            cx: -13.700645000000002,
            cy: -492.595148,
            cz: 3.334038999999999,
            tx: 0.574133,
            ty: -499.048716,
            tz: 0.81701,
          },
          1.5
        );
        // 可以进行右键移动
        controls.enablePan = true;
      }, 1500);
    } else {
      // 可以进行右键移动
      controls.enablePan = true;
    }
  };
  buttonCut() {
    let timer = setTimeout(() => {
      this.back[this.pdjMap["PDJ_A"].visible === false ? 0 : 1].style.display =
        "none";
      this.back[this.pdjMap["PDJ_A"].visible === false ? 1 : 0].style.display =
        "none";
      this.backPdj(
        this.pdjMap["PDJ_A"].visible === false ? "pdjD" : "pdjA",
        true
      );
      clearTimeout(timer);
    }, 300);
  }

  searchView(searchModel) {
    let model = t.runScene.modelEx.getModel(searchModel);
    let point = t.runScene.modelEx.getWorldLocal(model);
    if (
      model.parent.name === "D_part_B" ||
      model.parent.parent.name.indexOf("D_part_B") !== -1
    ) {
      t.runScene.modelEx.camAnima(
        t.runScene.modelEx.getCamLocal(),
        {
          cx: point.x,
          cy: point.y + 0.7,
          cz: point.z - 3,
          tx: point.x,
          ty: point.y,
          tz: point.z,
        },
        1.3,
        () => {
          if (searchModel.indexOf("06-B01") !== -1) {
            bus.emit("pdjd", searchModel);
          } else if (searchModel.indexOf("05-B01") !== -1) {
            bus.emit("pdja", searchModel);
          }
        }
      );
    } else {
      t.runScene.modelEx.camAnima(
        t.runScene.modelEx.getCamLocal(),
        {
          cx: point.x - 2.8,
          cy: point.y + 0.7,
          cz: point.z,
          tx: point.x,
          ty: point.y,
          tz: point.z,
        },
        1.3,
        () => {
          if (searchModel.indexOf("06-B01") !== -1) {
            bus.emit("pdjd", searchModel);
          } else if (searchModel.indexOf("05-B01") !== -1) {
            bus.emit("pdja", searchModel);
          }
        }
      );
    }
  }
}
class Ponintstate {
  environmentPoint = null;
  clickEnvironmentPoint = null;
  monitoringPoint = null;
  clickMonitoringPoint = null;
  backstagePointMapState;
  hoverUndergroundPointTextureMap;
  clickUndergroundPointTextureMap;
  undergroundPointTextureMap;
  undergroundClickPointName = "";
  undergroundCurrentPrice;
  undergroundPoint = null;
  undergroundPointMap = {
    "05": t.map.createMap("./assets/jingbao_p.png"),
    "06": t.map.createMap("./assets/jingbao_p.png"),
    正常: t.map.createMap("./assets/zhengchang-p.png"),
  };
  flag = t.runScene.modelEx.getModel("停车场牌子");
  angle = {
    "-1.57": 0,
    "1.57": 0,
    "-3.14": -3.14,
    "3.14": 3.14,
    "0": 3.14,
  };
  lastCar = null;
  temp = null;
  cliclCar = null;
  init() {
    // 修改地下消防点位中的轮廓光
    t.runScene.pp.params.outline.isOutline = false;
    console.log(t.runScene.pp, "t.runScene.pp.outlineParams");
    this.environmentPoint = {
      液位: {
        正常: t.map.createMap("./assets/shiwai_guanwang-zhengchang-moren.png"),
        告警: t.map.createMap("./assets/shiwai_guanwang-gaojing-moren.png"),
        待机: t.map.createMap("./assets/shiwai_guanwang-daiji-moren.png"),
      },
      空气: {
        正常: t.map.createMap(
          "./assets/shiwai_kongqizhiliang-zhengchang-moren.png"
        ),
        告警: t.map.createMap(
          "./assets/shiwai_kongqizhiliang-gaojing-moren.png"
        ),
        待机: t.map.createMap("./assets/shiwai_kongqizhiliang-daiji-moren.png"),
      },
      水质: {
        正常: t.map.createMap(
          "./assets/shiwai_shuihuanjing-zhengchang-moren.png"
        ),
        告警: t.map.createMap("./assets/shiwai_shuihuanjing-gaojing-moren.png"),
        待机: t.map.createMap("./assets/shiwai_shuihuanjing-daiji-moren.png"),
      },
    };
    this.clickEnvironmentPoint = {
      液位: {
        正常: t.map.createMap("./assets/shiwai_guanwang-zhengchang-dianji.png"),
        告警: t.map.createMap("./assets/shiwai_guanwang-gaojing-dianji.png"),
        待机: t.map.createMap("./assets/shiwai_guanwang-daiji-dianji.png"),
      },
      空气: {
        正常: t.map.createMap(
          "./assets/shiwai_kongqizhiliang-zhengchang-dianji.png"
        ),
        告警: t.map.createMap(
          "./assets/shiwai_kongqizhiliang-gaojing-dianji.png"
        ),
        待机: t.map.createMap(
          "./assets/shiwai_kongqizhiliang-daiji-dianji.png"
        ),
      },
      水质: {
        正常: t.map.createMap(
          "./assets/shiwai_shuihuanjing-zhengchang-dianji.png"
        ),
        告警: t.map.createMap(
          "./assets/shiwai_shuihuanjing-gaojing-dianji.png"
        ),
        待机: t.map.createMap("./assets/shiwai_shuihuanjing-daiji-dianji.png"),
      },
    };
    this.monitoringPoint = {
      外场监控: {
        正常: t.map.createMap("./assets/shiwai_jiankong-zhengchang-moren.png"),
        告警: t.map.createMap("./assets/shiwai_jiankong-gaojing-moren.png"),
        待机: t.map.createMap("./assets/shiwai_jiankong-daiji-moren.png"),
      },
    };
    this.clickMonitoringPoint = {
      外场监控: {
        正常: t.map.createMap("./assets/shiwai_jiankong-zhengchang-dianji.png"),
        告警: t.map.createMap("./assets/shiwai_jiankong-gaojing-dianji.png"),
        待机: t.map.createMap("./assets/shiwai_jiankong-daiji-dianji.png"),
      },
    };
    this.undergroundPointTextureMap = {
      "地下室-烟感": {
        待机: t.map.createMap("./assets/shinei_yangan-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_yangan-gaojing-moren.png"),
        正常: t.map.createMap("./assets/shinei_yangan-zhengchang-moren.png"),
        报警: t.map.createMap("./assets/yangan-waring-moren.png"),
      },
      "地下室-水表": {
        待机: t.map.createMap("./assets/shinei_shuibiao-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_shuibiao-gaojing-moren.png"),
        正常: t.map.createMap("./assets/shinei_shuibiao-zhengchang-moren.png"),
      },
      "地下室-电表": {
        待机: t.map.createMap("./assets/shinei_dianbiao-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_dianbiao-gaojing-moren.png"),
        正常: t.map.createMap("./assets/shinei_dianbiao-zhengchang-moren.png"),
      },
      "地下室-空气检测": {
        待机: t.map.createMap("./assets/shinei_kongqizhiliang-daiji-moren.png"),
        告警: t.map.createMap(
          "./assets/shinei_kongqizhiliang-gaojing-moren.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_kongqizhiliang-zhengchang-moren.png"
        ),
      },
      "地下室-网关": {
        待机: t.map.createMap("./assets/shinei_wangguan-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_wangguan-gaojing-moren.png"),
        正常: t.map.createMap("./assets/shinei_wangguan-zhengchang-moren.png"),
      },
      "地下室-监控": {
        待机: t.map.createMap("./assets/shinei_jishuikong-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_jishuikong-gaojing-moren.png"),
        正常: t.map.createMap(
          "./assets/shinei_jishuikong-zhengchang-moren.png"
        ),
      },
      "地下室-集水井": {
        待机: t.map.createMap("./assets/shinei_jishuijing-daiji-moren.png"),
        告警: t.map.createMap("./assets/shinei_jishuijing-gaojing-moren.png"),
        正常: t.map.createMap(
          "./assets/shinei_jishuijing-zhengchang-moren.png"
        ),
      },
      "地下室-消防门": {
        待机: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-daiji-moren.png"
        ),
        告警: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-gaojing-moren.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-zhengchang-moren.png"
        ),
      },
    };
    this.clickUndergroundPointTextureMap = {
      "地下室-烟感": {
        待机: t.map.createMap("./assets/shinei_yangan-daiji-dianji.png"),
        告警: t.map.createMap("./assets/shinei_yangan-gaojing-dianji.png"),
        正常: t.map.createMap("./assets/shinei_yangan-zhengchang-dianji.png"),
        报警: t.map.createMap("./assets/yangan-waring-dianji.png"),
      },
      "地下室-水表": {
        待机: t.map.createMap("./assets/shinei_shuibiao-daiji-dianji.png"),
        告警: t.map.createMap("./assets/shinei_shuibiao-gaojing-dianji.png"),
        正常: t.map.createMap("./assets/shinei_shuibiao-zhengchang-dianji.png"),
      },
      "地下室-电表": {
        待机: t.map.createMap("./assets/shinei_dianbiao-daiji-dianji.png"),
        告警: t.map.createMap("./assets/shinei_dianbiao-gaojing-dianji.png"),
        正常: t.map.createMap("./assets/shinei_dianbiao-zhengchang-dianji.png"),
      },
      "地下室-空气检测": {
        待机: t.map.createMap(
          "./assets/shinei_kongqizhiliang-daiji-dianji.png"
        ),
        告警: t.map.createMap(
          "./assets/shinei_kongqizhiliang-gaojing-dianji.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_kongqizhiliang-zhengchang-dianji.png"
        ),
      },
      "地下室-网关": {
        待机: t.map.createMap("./assets/shinei_wangguan-daiji-dianji.png"),
        告警: t.map.createMap("./assets/shinei_wangguan-gaojing-dianji.png"),
        正常: t.map.createMap("./assets/shinei_wangguan-zhengchang-dianji.png"),
      },
      "地下室-监控": {
        待机: t.map.createMap("./assets/shinei_jishuikong-daiji-dianji.png"),
        告警: t.map.createMap("./assets/shinei_jishuikong-gaojing-dianji.png"),
        正常: t.map.createMap(
          "./assets/shinei_jishuikong-zhengchang-dianji.png"
        ),
      },
      "地下室-集水井": {
        待机: t.map.createMap("./assets/shinei_jishuijing-daiji-dianji.png"),
        告警: t.map.createMap("./assets/shinei_jishuijing-gaojing-dianji.png"),
        正常: t.map.createMap(
          "./assets/shinei_jishuijing-zhengchang-dianji.png"
        ),
      },
      "地下室-消防门": {
        待机: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-daiji-dianji.png"
        ),
        告警: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-gaojing-dianji.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-zhengchang-dianji.png"
        ),
      },
    };
    this.hoverUndergroundPointTextureMap = {
      "地下室-烟感": {
        待机: t.map.createMap("./assets/shinei_yangan-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/shinei_yangan-gaojing-chupeng.png"),
        正常: t.map.createMap("./assets/shinei_yangan-zhengchang-chupeng.png"),
        报警: t.map.createMap("./assets/yangan-waring-chupeng.png"),
      },
      "地下室-水表": {
        待机: t.map.createMap("./assets/shinei_shuibiao-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/shinei_shuibiao-gaojing-chupeng.png"),
        正常: t.map.createMap(
          "./assets/shinei_shuibiao-zhengchang-chupeng.png"
        ),
      },
      "地下室-电表": {
        待机: t.map.createMap("./assets/shinei_dianbiao-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/shinei_dianbiao-gaojing-chupeng.png"),
        正常: t.map.createMap(
          "./assets/shinei_dianbiao-zhengchang-chupeng.png"
        ),
      },
      "地下室-空气检测": {
        待机: t.map.createMap(
          "./assets/shinei_kongqizhiliang-daiji-chupeng.png"
        ),
        告警: t.map.createMap(
          "./assets/shinei_kongqizhiliang-gaojing-chupeng.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_kongqizhiliang-zhengchang-chupeng.png"
        ),
      },
      "地下室-网关": {
        待机: t.map.createMap("./assets/shinei_wangguan-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/shinei_wangguan-gaojing-chupeng.png"),
        正常: t.map.createMap(
          "./assets/shinei_wangguan-zhengchang-chupeng.png"
        ),
      },
      "地下室-监控": {
        待机: t.map.createMap("./assets/shinei_jishuikong-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/shinei_jishuikong-gaojing-chupeng.png"),
        正常: t.map.createMap(
          "./assets/shinei_jishuikong-zhengchang-chupeng.png"
        ),
      },
      "地下室-集水井": {
        待机: t.map.createMap("./assets/shinei_jishuijing-daiji-chupeng.png"),
        告警: t.map.createMap("./assets/shinei_jishuijing-gaojing-chupeng.png"),
        正常: t.map.createMap(
          "./assets/shinei_jishuijing-zhengchang-chupeng.png"
        ),
      },
      "地下室-消防门": {
        待机: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-daiji-chupeng.png"
        ),
        告警: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-gaojing-chupeng.png"
        ),
        正常: t.map.createMap(
          "./assets/shinei_xiaofangjuanlianmen-zhengchang-chupeng.png"
        ),
      },
    };
  }
  pointStateMap(pointMapState, pointMap, state, clickModelName) {
    if (pointMapState.length === 0) return;
    if (clickModelName) {
      pointMapState.map((i) => {
        const pointModelMap = t.runScene.modelEx.getModel(i);
        if (!pointModelMap) return
        pointModelMap.material = pointModelMap.material.clone();
        t.map.changeMap(
          pointModelMap,
          this.environmentPoint[pointModelMap.parent.name][state],
          "map"
        );
        if (i === clickModelName) {
          t.map.changeMap(
            pointModelMap,
            pointMap[pointModelMap.parent.name][state],
            "map"
          );
        }
      });
    } else {
      pointMapState.map((i) => {
        const pointModelMap = t.runScene.modelEx.getModel(i);
        if (!pointModelMap || pointModelMap.parent.name === "外场监控") return;
        pointModelMap.material = pointModelMap.material.clone();
        t.map.changeMap(
          pointModelMap,
          pointMap[pointModelMap.parent.name][state],
          "map"
        );
      });
    }
  }
  cameraPointStateMap(
    cameraPointMapState,
    cameraPointMap,
    cameraState,
    clickModelName
  ) {
    if (cameraPointMapState.length === 0) return;
    if (clickModelName) {
      cameraPointMapState.map((i) => {
        const pointModelMap = t.runScene.modelEx.getModel(i);
        pointModelMap.material = pointModelMap.material.clone();
        t.map.changeMap(
          pointModelMap,
          this.monitoringPoint[pointModelMap.parent.name][cameraState],
          "map"
        );
        if (i === clickModelName) {
          t.map.changeMap(
            pointModelMap,
            cameraPointMap[pointModelMap.parent.name][cameraState],
            "map"
          );
        }
      });
    } else {
      cameraPointMapState.map((i) => {
        const pointModelMap = t.runScene.modelEx.getModel(i);
        if (!pointModelMap || pointModelMap?.parent?.parent?.name === "环境监测点位") return;
        pointModelMap.material = pointModelMap.material.clone();
        t.map.changeMap(
          pointModelMap,
          cameraPointMap[pointModelMap.parent.name][cameraState],
          "map"
        );
      });
    }
  }

  undergroundPointStateMap(
    undergroundPointMapState,
    undergroundPointMap,
    state,
    clickModelName,
    initialPointMapState
  ) {
    if (!undergroundPointMapState) return;
    if (undergroundPointMapState.length === 0) return;
    if (clickModelName) {
      undergroundPointMapState.map((i) => {
        const pointModelMap = t.runScene.modelEx.getModel(i);
        pointModelMap.material = pointModelMap.material.clone();
        t.map.changeMap(
          pointModelMap,
          initialPointMapState[pointModelMap.parent.name][state],
          "map"
        );
        if (i === clickModelName) {
          t.map.changeMap(
            pointModelMap,
            undergroundPointMap[pointModelMap.parent.name][state],
            "map"
          );
          this.undergroundCurrentPrice = state;
        }
      });
    } else {
      undergroundPointMapState.map((i) => {
        const pointModelMap = t.runScene.modelEx.getModel(i);
        if (!pointModelMap) return;
        if (!undergroundPointMap[pointModelMap.parent.name]) return;
        pointModelMap.material = pointModelMap.material.clone();
        t.map.changeMap(
          pointModelMap,
          undergroundPointMap[pointModelMap.parent.name][state],
          "map"
        );
        this.undergroundCurrentPrice = state;
      });
    }
  }
  undergroundHoverPointMap(hoverMap, state) {
    if (!hoverMap) return;
    if (hoverMap.length === 0) return;
    let hoverModelMap = [];
    hoverMap.map((i) => {
      let modelMap = t.runScene.modelEx.getModel(i);
      if (modelMap === undefined) return false;
      if (
        modelMap.parent.name === "地下室-网关" ||
        modelMap.parent.name === "地下室-监控" ||
        modelMap.parent.name === "地下室-空气检测" ||
        modelMap.parent.name === "地下室-电表" ||
        modelMap.parent.name === "地下室-烟感" ||
        modelMap.parent.name === "地下室-集水井" ||
        modelMap.parent.name === "地下室-消防门" ||
        modelMap.parent.name === "地下室-水表"
      ) {
        hoverModelMap.push(modelMap);
      }
    });
    console.log(hoverModelMap, "地下hoverModelMap");
    let sb = hoverModelMap.map((i) => i.name);
    if (
      this.undergroundClickPointName != "" &&
      sb.includes(this.undergroundClickPointName)
    ) {
      let clickPointModel = t.runScene.modelEx.getModel(
        this.undergroundClickPointName
      );
      t.map.changeMap(
        clickPointModel,
        this.clickUndergroundPointTextureMap[clickPointModel.parent.name][
        state
        ],
        "map"
      );
      this.undergroundCurrentPrice = state;
    }
    t.runScene.modelEx.getHoverFromModels(hoverModelMap, (models) => {
      if (models) {
        this.findModel = models.find((model) =>
          t.runScene.modelEx.deepIsVisible(model)
        );
        if (!this.findModel) return;
        hoverModelMap.map((i) => {
          t.map.changeMap(
            i,
            this.undergroundPointTextureMap[i.parent.name][state],
            "map"
          );
        });
        if (this.undergroundClickPointName != "") {
          let clickPointModel = t.runScene.modelEx.getModel(
            this.undergroundClickPointName
          );
          t.map.changeMap(
            clickPointModel,
            this.clickUndergroundPointTextureMap[clickPointModel.parent.name][
            this.undergroundCurrentPrice
            ],
            "map"
          );
        }
        t.map.changeMap(
          this.findModel,
          this.hoverUndergroundPointTextureMap[this.findModel.parent.name][
          state
          ],
          "map"
        );
      } else {
        if (!this.findModel) return;
        hoverModelMap.map((i) => {
          t.map.changeMap(
            i,
            this.undergroundPointTextureMap[i.parent.name][state],
            "map"
          );
          if (i.name == this.undergroundClickPointName) {
            t.map.changeMap(
              i,
              this.clickUndergroundPointTextureMap[i.parent.name][state],
              "map"
            );
          }
        });
      }
    });
  }
  allPointMap(model, res) {
    t.ponintstate.undergroundClickPointName = model.name;
    bus.emit("dialogNumber", model.name);
    let { normal, fault, standby, fireAlarm } = res;
    let dainNormal = [];
    let dainFault = [];
    let dainStandby = [];
    let dainFireAlarm = [];
    normal.map((i) => {
      let modelState = t.runScene.modelEx.getModel(i);
      if (modelState === undefined) return false;
      if (modelState.parent.name === model.parent.name) {
        dainNormal.push(i);
      }
    });
    fault.map((i) => {
      let modelState = t.runScene.modelEx.getModel(i);
      if (modelState === undefined) return false;
      if (modelState.parent.name === model.parent.name) {
        dainFault.push(i);
      }
    });
    standby.map((i) => {
      let modelState = t.runScene.modelEx.getModel(i);
      if (modelState === undefined) return false;
      if (modelState.parent.name === model.parent.name) {
        dainStandby.push(i);
      }
    });
    t.parking.routerToParking[bus.emit("getRouter")] === "烟感" &&
      fireAlarm.map((i) => {
        let modelState = t.runScene.modelEx.getModel(i);
        if (modelState === undefined) return false;
        if (modelState.parent.name === model.parent.name) {
          dainFireAlarm.push(i);
        }
      });
    if (
      model.parent.name === "地下室-空气检测" ||
      model.parent.name === "地下室-集水井"
    ) {
      t.border.setSpritePosition(t.runScene.modelEx.getModel(model.name));
    }
    t.ponintstate.undergroundPointStateMap(
      dainNormal,
      t.ponintstate.clickUndergroundPointTextureMap,
      "正常",
      model.name,
      t.ponintstate.undergroundPointTextureMap
    );
    t.ponintstate.undergroundPointStateMap(
      dainFault,
      t.ponintstate.clickUndergroundPointTextureMap,
      "告警",
      model.name,
      t.ponintstate.undergroundPointTextureMap
    );
    t.ponintstate.undergroundPointStateMap(
      dainStandby,
      t.ponintstate.clickUndergroundPointTextureMap,
      "待机",
      model.name,
      t.ponintstate.undergroundPointTextureMap
    );
    t.parking.routerToParking[bus.emit("getRouter")] === "烟感" &&
      t.ponintstate.undergroundPointStateMap(
        dainFireAlarm,
        t.ponintstate.clickUndergroundPointTextureMap,
        "报警",
        model.name,
        t.ponintstate.undergroundPointTextureMap
      );
  }
  // 停车管理车子聚焦
  searchCarView(searchModel) {
    this.temp = null;
    this.cliclCar = t.runScene.modelEx.getModel("Car" + searchModel);
    this.cliclCar.material = this.cliclCar.material.clone();
    if (this.lastCar) {
      this.temp = this.lastCar;
    } else {
      this.temp = this.cliclCar;
    }
    this.lastCar = this.cliclCar;
    if (this.temp) {
      this.temp.material.color = new THREE.Color(`rgb(7,138,159)`);
    }
    this.cliclCar.material.color = new THREE.Color(`rgb(19, 206, 102)`);
    if (!this.cliclCar) return;
    let point = t.runScene.modelEx.getWorldLocal(this.cliclCar);
    let pz =
      Math.abs(this.cliclCar.rotation.z.toFixed(2)) === 3.14 ||
      Math.abs(this.cliclCar.rotation.z.toFixed(2)) === 0;
    let pzView;
    pz ? (pzView = 0) : (pzView = 15),
      t.runScene.modelEx.camAnima(
        t.runScene.modelEx.getCamLocal(),
        {
          cx:
            point.x +
            this.angle[
            ((this.cliclCar.rotation.z.toFixed(2) * 100) / 100).toString()
            ],
          cy: point.y + 8,
          cz: point.z + pzView,
          tx: point.x,
          ty: point.y,
          tz: point.z,
        },
        0.5,
        () => { }
      );
  }
}
// 基本事件
class Events {
  autoRotateSpeed = 0;
  downPosition = {
    x: 0,
    y: 0,
  };
  camera2DPosition = {};
  closeAnimaAtStart = {
    backAnima: t.floor.backAnima,
    // enterAnima: "",
    // spriteAnima: "",
    // anima: "",
  };
  isClick = true;
  strike = false;
  constructor() {
    t.runScene.assetsEx.controls.addEventListener("start", this.controlStart);
    t.runScene.cb.events.pointer.down.add("pointerDown", this.mouseDown);
    window.addEventListener("pointerdown", (e) => {
      console.log(e, "e");
    });
    t.runScene.cb.events.pointer.up.add("pointerUp", this.mouseUp);
    t.runScene.cb.model.setSelect.add(
      "trigger-click",
      this.triggerClick.bind(this)
    );
    document.addEventListener("click", (e) => {
      this.camera2DPosition = {
        x: e.pageX,
        y: e.pageY,
      };
    });
    t.runScene.cb.events.pointer.down.add("trigger", (e) => {
      t.runScene.modelEx.selectNull();
      this.logAllObject(e);
    });
  }
  // 设置位置 返回2D点位
  setPosition(ps) {
    let world_vector = new THREE.Vector3(ps.x, ps.y, ps.z);
    let vector = world_vector.project(camera);
    let halfWidth = window.innerWidth / 2,
      halfHeight = window.innerHeight / 2;
    return {
      x: Math.round(vector.x * halfWidth + halfWidth),
      y: Math.round(-vector.y * halfHeight + halfHeight),
    };
  }
  changeClickState(isClick) {
    // this.isClick = isClick;
    t.floorExplosion.floorBQVisible(isClick);
  }
  // 场景自转
  autoRotate() {
    t.runScene.cb.render.add("autoRotate", () => {
      t.runScene.assetsEx.controls.autoRotate = true;
      t.runScene.assetsEx.controls.autoRotateSpeed = this.autoRotateSpeed;
      t.runScene.assetsEx.controls.update();
    });
  }
  showAnima(info) {
    const { model, isShow, time, cb, opacity } = info;
    const models = [];
    model.traverse((m) => {
      if (m.type === "Group") return;
      if (m.type === "Object3D") return;
      m.material.transparent = true;
      isShow ? (m.material.opacity = 0) : null;
      models.push(m);
    });
    if (isShow) model.visible = isShow;
    Utils.anima(
      {
        opc: isShow ? 0 : opacity || 1,
      },
      {
        opc: isShow ? opacity || 1 : 0,
      },
      time,
      (data) => {
        models.map((m) => (m.material.opacity = data.opc));
      },
      () => {
        if (!isShow) model.visible = isShow;
        cb && cb();
      }
    );
  }
  // cameraFoucs(position, time = 1, fn) {
  //         // 场景点击功能接口开关
  //         t.events.closeAnimaAtStart.anima = Utils.anima({
  //                 cx: t.runScene.assetsEx.camera.position.x,
  //                 cy: t.runScene.assetsEx.camera.position.y,
  //                 cz: t.runScene.assetsEx.camera.position.z,
  //                 tx: t.runScene.assetsEx.controls.target.x,
  //                 ty: t.runScene.assetsEx.controls.target.y,
  //                 tz: t.runScene.assetsEx.controls.target.z,
  //             }, {}, {
  //                 ...position,
  //             },
  //             time,
  //             (data) => {
  //                 t.runScene.assetsEx.camera.position.set(data.cx, data.cy, data.cz);
  //                 t.runScene.assetsEx.controls.target.set(data.tx, data.ty, data.tz);
  //                 t.runScene.assetsEx.camera.updateProjectionMatrix();
  //                 t.runScene.assetsEx.controls.update();
  //             },
  //             () => {
  //                 fn && fn();
  //             }
  //         );
  //     }
  // 场景点击功能接口开关
  switchSceneClick(isClick) {
    this.isClick = isClick;
  }

  triggerClick = (model) => {
    if (!this.isClick) return;
    if (!model) return;
    console.log(model, "model");
    console.log(
      `cx:${camera.position.x}, cy:${camera.position.y}, cz:${camera.position.z}, tx:${controls.target.x}, ty:${controls.target.y}, tz:${controls.target.z} `,
      "位置"
    );
    this.sceneClickEvent(model);

    bus.emit("logClickModel", model);
    // t.floorExplosion.clickFloorUi(model.name);
    // 聚焦大楼
    // t.floorExplosion.focusBuilding(model.name);
  };
  logAllObject = (e) => {
    const { intersects, obj } = t.runScene.modelEx.getClickObj(
      e,
      scene.children,
      true
    );
    if (intersects) {
      let carModel = null;
      for (const iterator of intersects) {
        if (
          iterator.object.name.indexOf("Car") != -1 &&
          iterator.object.name.indexOf("墙壁") == -1
        ) {
          carModel = iterator.object.name.split("Car").pop();
          bus.emit("clickCar", carModel);
          return;
        }
        if (
          iterator.object.parent.name == "外场监控"
          // iterator.object.parent.name == "环境监测点位"
        ) {
          bus.emit("dialogNumber", iterator.object.name);
          t.border.setSpritePosition(iterator.object);
          this.strike = true;
          return;
        } else {
          this.strike = false;
        }
        if (iterator.object.name.indexOf("停车场牌子") != -1) {
          t.parking.sbParking(true);
          return;
        }
      }
    }
  };
  controlStart = () => {
    if (t.switchover.isBlack) return;
    if (t.border.mySprite.visible) {
      t.border.spriteMyVisible(false);
    }
    t.floor.backAnima && t.floor.backAnima.kill();
    // 关闭其他动画
    // this.stopMove();
    this.closeAnmia();
  };
  stopMove = () => {
    let cameraPosition = camera.position;
    let dis = cameraPosition.distanceTo({
      x: 43.566655418092495,
      y: 1.6709615566462421,
      z: -553.1862754116212,
    });
    if (dis >= 850) {
      controls.enablePan = false;
      // 1.5秒后恢复
      Utils.getMacro(() => {
        // 重新恢复至初始视角动静
        // t.entranceAmin();
        t.runScene.modelEx.camAnima(
          t.runScene.modelEx.getCamLocal(),
          {
            cx: -105.03348077963417,
            cy: 40.37114448685633,
            cz: 104.84462157439785,
            tx: 86.37024471104505,
            ty: -6.538917075837168,
            tz: 183.75998868759436,
            tz: 183.75998868759436,
          },
          1.5
        );
        // 可以进行右键移动
        controls.enablePan = true;
      }, 1500);
    } else {
      // 可以进行右键移动
      controls.enablePan = true;
    }
  };
  closeAnmia() {
    Object.values(this.closeAnimaAtStart).map((item) => {
      // 暂停动画 并清空内容 item就是那个动画
      item && item.kill();
    });
  }
  dispose() {
    dom.removeEventListener("pointerdown", this.mouseDown);
    dom.removeEventListener("pointerup", this.mouseUp);
    controls.removeEventListener("start", this.controlStart);
  }
  //场景点击事件
  sceneClickEvent(model) {
    if (!model) return;
    if (model) {
      t.border.spriteMyVisible(false);
    }
    if (
      model.name === "Az" ||
      model.name === "Bz" ||
      model.name === "Cz" ||
      model.name === "Dz" ||
      model.name === "人防z"
    ) {
      let data = model.name.split("z")[0];
      if (bus.list.getClickBuild) bus.emit("getClickBuild", `${data}区地下室`);
    }
    if (t.pdjevent.isState) {
      if (model.name.indexOf("06-B01") !== -1) {
        t.pdjevent.clickModel = true;
        t.runScene.multipSelector.setEmpty();
        t.runScene.multipSelector.add(model);
        bus.emit("pdjd", model.name);
      } else if (model.name.indexOf("05-B01") !== -1) {
        t.pdjevent.clickModel = true;
        t.runScene.multipSelector.setEmpty();
        t.runScene.multipSelector.add(model);
        bus.emit("pdja", model.name);
      } else {
        t.pdjevent.clickModel = false;
        t.runScene.multipSelector.setEmpty();
        bus.emit("closepdja");
      }
    }
    if (model.name.indexOf("标签") != -1) {
      let build = model.name.split("标签")[0].split("_")[0];
      let floor = model.name.split("标签")[0].split("_")[1];
      t.floor.floorDispose(build, floor);
      if (model.name.indexOf("6") != -1) {
        t.floor.shell(build, true);
      }
      t.floor.floorLabelMap(model, floor, "点击");
    }
    if (model.parent.name === "外场监控") {
      let { normal, fault, standby } = t.ponintstate.backstagePointMapState;
      t.ponintstate.cameraPointStateMap(
        normal,
        t.ponintstate.clickMonitoringPoint,
        "正常",
        model.name
      );
      t.ponintstate.cameraPointStateMap(
        fault,
        t.ponintstate.clickMonitoringPoint,
        "告警",
        model.name
      );
      t.ponintstate.cameraPointStateMap(
        standby,
        t.ponintstate.clickMonitoringPoint,
        "待机",
        model.name
      );
    } else {
      if (t.ponintstate.backstagePointMapState) {
        bus.list.closeShowDialog && bus.emit("closeShowDialog", false);
        let { normal, fault, standby } = t.ponintstate.backstagePointMapState;
        t.ponintstate.cameraPointStateMap(
          normal,
          t.ponintstate.monitoringPoint,
          "正常"
        );
        t.ponintstate.cameraPointStateMap(
          fault,
          t.ponintstate.monitoringPoint,
          "告警"
        );
        t.ponintstate.cameraPointStateMap(
          standby,
          t.ponintstate.monitoringPoint,
          "待机"
        );
      }
    }
    if (
      model.parent.name.indexOf("_电表") != -1 ||
      model.parent.name.indexOf("_烟感") != -1 ||
      model.parent.name.indexOf("_水表") != -1 ||
      model.parent.name.indexOf("_水空调") != -1 ||
      model.parent.name.indexOf("_网关") != -1 ||
      model.parent.name.indexOf("_室内空气") != -1 ||
      model.parent.name.indexOf("_监控") != -1 ||
      model.parent.name.indexOf("电梯点位") != -1 ||
      model.parent.name.indexOf("_vrv空调") != -1
    ) {
      if (model.parent.name == "外场监控") return;
      bus.emit("dialogClose");
      bus.emit("dialogNumber", model.name);
      t.border.setSpritePosition(model);
      //hhh
    } else {
      if (!this.strike) {
        // t.border.spriteVisible(false);
        bus.emit("dialogClose");
      }
    }
    if (model.parent.name == "点击组") {
      if (
        t.parking.clickArea != "all" &&
        t.parking.clickArea != null &&
        t.parking.clickArea.name == model.name
      ) {
        t.parking.focusArea(model.name.split("z")[0]);
        bus.emit("parkingArea", model.name.split("z")[0]);
      }
      if (t.parking.clickArea == null) {
        t.parking.focusArea(model.name.split("z")[0]);
        bus.emit("parkingArea", model.name.split("z")[0]);
      }
      if (t.parking.clickArea == "all") {
        t.parking.focusArea(model.name.split("z")[0]);
        bus.emit("parkingArea2", model.name.split("z")[0]);
      }
    }
    if (model.name.indexOf("SBF_泵") !== -1) {
      t.shuipump.setpsSpritePosition(model);
      bus.emit("sbfClick", model.name);
      t.shuipump.clickPoint(
        t.shuipump.stateArray,
        t.shuipump.clickSbfPoint,
        t.shuipump.sbfPonit,
        model
      );
      t.shuipump.clickPointName = model.name;
    } else {
      t.shuipump.clickPointName = "";
      t.shuipump.changeFloorBqXh(t.shuipump.stateArray);
    }
    if (model.parent?.parent?.name == "环境监测点位") {
      t.border.setSpritePosition(model);
      bus.emit("empNumber", model.name);
    }
    // else {
    //     t.border.spriteVisible(false);
    // }
    // if (model.parent.name == "外场监控") {
    //     bus.emit("mitNumber", model.name);
    // }
    if (model) {
      getAllChildrenModel(t.pdjevent.pdjA["A_part_B"]["model"]).map((i) => {
        if (model.name === i.name) {
          t.pdjevent.clickMethod = true;
          t.pdjevent.setPdjA(t.pdjevent.pdjA, t.pdjevent.pdjA1, "A_part_B");
        }
      });
      getAllChildrenModel(t.pdjevent.pdjA["A_part_A"]["model"]).map((i) => {
        if (model.name === i.name) {
          t.pdjevent.clickMethod = true;
          t.pdjevent.setPdjA(t.pdjevent.pdjA, t.pdjevent.pdjA1, "A_part_A");
        }
      });
      getAllChildrenModel(t.pdjevent.pdjD["D_part_A"]["model"]).map((i) => {
        if (model.name === i.name) {
          t.pdjevent.clickMethod = true;
          t.pdjevent.setPdjA(t.pdjevent.pdjD, t.pdjevent.pdjD1, "D_part_A");
        }
      });
      getAllChildrenModel(t.pdjevent.pdjD["D_part_B"]["model"]).map((i) => {
        if (model.name === i.name) {
          t.pdjevent.clickMethod = true;
          t.pdjevent.setPdjA(t.pdjevent.pdjD, t.pdjevent.pdjD1, "D_part_B");
        }
      });
    }
    if (
      model.parent.name.indexOf("_电表") != -1 ||
      model.parent.name.indexOf("_烟感") != -1 ||
      model.parent.name.indexOf("_水表") != -1 ||
      model.parent.name.indexOf("_水空调") != -1 ||
      model.parent.name.indexOf("_vrv空调") != -1 ||
      model.parent.name.indexOf("_网关") != -1 ||
      model.parent.name.indexOf("_室内空气") != -1 ||
      model.parent.name.indexOf("_监控") != -1
    ) {
      // bus.emit("dialogNumber", model.name);
      t.floor.judge(
        t.floor.myPointStateMap.normal,
        "正常",
        t.floor.clickPointTextureMap,
        t.floor.pointTextureMap,
        model
      );
      t.floor.judge(
        t.floor.myPointStateMap.fault,
        "告警",
        t.floor.clickPointTextureMap,
        t.floor.pointTextureMap,
        model
      );
      t.floor.judge(
        t.floor.myPointStateMap.standby,
        "待机",
        t.floor.clickPointTextureMap,
        t.floor.pointTextureMap,
        model
      );
      model.parent.name.indexOf("_烟感") != -1 &&
        t.floor.judge(
          t.floor.myPointStateMap.fireAlarm,
          "报警",
          t.floor.clickPointTextureMap,
          t.floor.pointTextureMap,
          model
        );
      t.floor.clickPointName = model.name;
    } else {
      t.floor.clickPointName = "";
      if (t.floor.myPointStateMap) {
        bus.emit("dialogClose");
        t.floor.initClick(t.floor.myPointStateMap.normal, "正常");
        t.floor.initClick(t.floor.myPointStateMap.fault, "告警");
        t.floor.initClick(t.floor.myPointStateMap.standby, "待机");
      }
    }
    if (model.parent?.parent?.name == "环境监测点位") {
      let { normal, fault, standby } = t.ponintstate.backstagePointMapState;
      t.ponintstate.pointStateMap(
        normal,
        t.ponintstate.clickEnvironmentPoint,
        "正常",
        model.name
      );
      t.ponintstate.pointStateMap(
        fault,
        t.ponintstate.clickEnvironmentPoint,
        "告警",
        model.name
      );
      t.ponintstate.pointStateMap(
        standby,
        t.ponintstate.clickEnvironmentPoint,
        "待机",
        model.name
      );
    } else {
      if (t.ponintstate.backstagePointMapState) {
        let { normal, fault, standby } = t.ponintstate.backstagePointMapState;
        t.ponintstate.pointStateMap(
          normal,
          t.ponintstate.environmentPoint,
          "正常"
        );
        t.ponintstate.pointStateMap(
          fault,
          t.ponintstate.environmentPoint,
          "告警"
        );
        t.ponintstate.pointStateMap(
          standby,
          t.ponintstate.environmentPoint,
          "待机"
        );
      }
    }
    if (model.parent.name === "地下室-水表") {
      t.ponintstate.allPointMap(model, t.parking.undergroundAlldata);
    } else {
      if (t.parking.undergroundAlldata && t.parking.isPraking) {
        t.border.spriteVisible(false);
        let {
          normal,
          fault,
          standby,
          fireAlarm,
        } = t.parking.undergroundAlldata;
        t.ponintstate.undergroundPointStateMap(
          normal,
          t.ponintstate.undergroundPointTextureMap,
          "正常"
        );
        t.ponintstate.undergroundPointStateMap(
          fault,
          t.ponintstate.undergroundPointTextureMap,
          "告警"
        );
        t.ponintstate.undergroundPointStateMap(
          standby,
          t.ponintstate.undergroundPointTextureMap,
          "待机"
        );
        t.ponintstate.undergroundPointStateMap(
          fireAlarm,
          t.parking.routerToParking[bus.emit("getRouter")] &&
          t.ponintstate.undergroundPointTextureMap,
          "报警"
        );
        t.ponintstate.undergroundClickPointName = "";
      }
    }
    if (
      model.parent.name === "地下室-网关" ||
      model.parent.name === "地下室-监控" ||
      model.parent.name === "地下室-空气检测" ||
      model.parent.name === "地下室-电表" ||
      model.parent.name === "地下室-烟感"
    ) {
      t.ponintstate.allPointMap(model, t.parking.undergroundAlldata);
    }
    if (model.parent.name === "地下室-集水井") {
      t.ponintstate.allPointMap(model, t.parking.undergroundAlldata);
    }
    if (model.parent.name === "地下室-消防门") {
      t.ponintstate.allPointMap(model, t.parking.undergroundAlldata);
    }
    if (model.name === "停车场牌子") {
      if (t.ponintstate.undergroundPoint) {
        t.map.changeMap(
          t.ponintstate.flag,
          t.ponintstate.undergroundPointMap[t.ponintstate.undergroundPoint],
          "map"
        );
      } else {
        t.map.changeMap(
          t.ponintstate.flag,
          t.ponintstate.undergroundPointMap["正常"],
          "map"
        );
      }
    }
    if (model.name.indexOf("Car") !== -1) {
      t.ponintstate.cliclCar = model;
      t.ponintstate.cliclCar.material = t.ponintstate.cliclCar.material.clone();
      if (t.ponintstate.lastCar) {
        t.ponintstate.temp = t.ponintstate.lastCar;
      } else {
        t.ponintstate.temp = t.ponintstate.cliclCar;
      }
      t.ponintstate.lastCar = t.ponintstate.cliclCar;
      if (t.ponintstate.temp) {
        t.ponintstate.temp.material.color = new THREE.Color(`rgb(7,138,159)`);
      }
      t.ponintstate.cliclCar.material.color = new THREE.Color(
        `rgb(19, 206, 102)`
      );
    } else {
      if (t.ponintstate.cliclCar) {
        t.ponintstate.cliclCar.material.color = new THREE.Color(
          `rgb(7,138,159)`
        );
      }
    }
  }
  //场景自转调用
  autoRotation(Rotate) {
    Rotate ? (this.autoRotateSpeed = 2) : (this.autoRotateSpeed = 0);
  }
}
class Hover {
  hoverModerMap = [];
  constructor() { }
  init() {
    this.hoverModerMap = getAllChildrenModel(
      t.runScene.modelEx.getModel("PDJ_A")
    )
      .map((i) => {
        if (i.name.indexOf("05-") != -1) {
          return i;
        }
      })
      .concat(
        getAllChildrenModel(t.runScene.modelEx.getModel("PDJ_D")).map((i) => {
          if (i.name.indexOf("06-") != -1) {
            return i;
          }
        })
      );
    let hoverMap = [];
    this.hoverModerMap.map((i) => {
      i && hoverMap.push(i);
    });
    t.runScene.modelEx.getHoverFromModels(hoverMap, (models) => {
      if (models) {
        const findModel = models.find((model) =>
          t.runScene.modelEx.deepIsVisible(model)
        );
        if (!findModel) return;
        if (!t.pdjevent.clickModel) {
          t.runScene.multipSelector.setEmpty();
          t.runScene.multipSelector.add(findModel);
        }
      }
    });
  }
}
//所有bus传值
class BusEvent {
  constructor() { }
  init() {
    this.on();
    console.log("bus");
  }
  //注册
  on() {
    //开启灯光的bus
    bus.on("light", (isShow) => {
      t.floor.setLight(isShow);
      let glow;
      isShow ? (glow = 5) : (glow = 1.5);
      t.runScene.pp.setGlowData("strength", glow);
    });
    bus.on("openFloorLabel", (isOpen) => {
      t.floor.showFloorBq = isOpen;
    });
    bus.on("showFloorPoint", (type) => {
      t.floor.setTypePoint(type);
    });
    bus.on("back", (cb) => {
      t.border.spriteMyVisible(false);
      t.parking.queryUnderTimer && clearInterval(t.parking.queryUnderTimer);
      if (t.parking.isPraking) {
        t.switchover.closeBoo(() => {
          t.floor.backToMr(() => {
            t.parking.quitParking();
            t.switchover.openBoo();
          }, 0.5);
        });
      } else {
        t.floor.backToMr(cb);
      }
    });
    bus.on("changeScene", (which, data = true) => {
      t.switchover.changeScene(which, data);
    });
    bus.on("createDialogs", (className) => {
      t.border.domToSprite(className);
    });
    bus.on("emp", (isShow) => {
      // let timer = setTimeout(() => {
      //   t.border.showEmp(isShow);
      //   clearTimeout(timer);
      // }, 150);
      t.border.showEmp(isShow);
    });
    bus.on("mit", (isShow) => {
      let timer = setTimeout(() => {
        t.border.showMit(isShow);
        clearTimeout(timer);
      }, 150);
    });
    bus.on("removeDialogs", () => {
      t.border.removeSprite();
    });
    bus.on("closeDialogs", () => {
      t.border.spriteVisible(false);
    });
    bus.on("changeFloorBqMap", (pumpArray) => {
      t.shuipump.changeFloorBqXh(pumpArray);
    });
    bus.on("liquidLevel", (zong, dang) => {
      t.shuipump.liquidLevel(zong, dang);
    });
    bus.on("parking", async (go) => {
      await t.switchover.closeBoo();
      // t.parking.createCar();
      t.floor.backToMr(() => {
        if (t.parking.isPraking) {
          t.parking.quitParking();
        }
        t.parking.goToParking(go);
        t.parking.dxsPoint.children.map((i) => {
          if (i.name == "地下室_集水井") return;
          i.visible = !go;
        });
        t.switchover.openBoo();
        if (!go) {
          t.parking.removeCar();
        }
      }, 0.5);
    });
    bus.on("lift", (isShow) => {
      t.floor.showLift(isShow);
      // bus.emit('back')
    });
    bus.on("removeSprite", () => {
      t.shuipump.removeSprite(t.shuipump.sprite);
    });
    bus.on("parking-mr", () => {
      t.parking.focusArea("初始");
    });
    bus.on("getCarPoint", (num) => {
      num && t.parking.getCarNum(num);
    });
    bus.on("getLiftNumber", (num) => {
      num && t.floor.getLift(num);
    });
    bus.on("liftMove", (liftNum, state, floor, status) => {
      t.floor.liftMove(liftNum, state, floor, status);
    });
    bus.on("psRemoveSprite", () => {
      t.shuipump.removeSprite(t.shuipump.psSprite);
    });
    bus.on("chooseFloorPoint", (build, floor, pointNum, name) => {
      if (t.parking.isPraking) {
        t.parking.sbParking(false, () => {
          t.parking.quitParking();
          t.floor.focusFloorPoint(build, floor, pointNum);
        });
      } else {
        t.floor.focusFloorPoint(build, floor, pointNum);
      }
    });
    bus.on("chooseParkingPoint", (num, name) => {
      t.parking.focusParingPoint(num);
    });
    bus.on("noFixed", () => {
      t.pdjevent.reset();
      t.pdjevent.conceal(t.pdjevent.pdjA, t.pdjevent.pdjA1);
      t.pdjevent.conceal(t.pdjevent.pdjD, t.pdjevent.pdjD1);
    });
    bus.on("buttonCut", () => {
      t.pdjevent.buttonCut();
    });
    bus.on("hiddenBuildSprite", (isShow) => {
      t.floor.hiddenBuildSprite(isShow);
    });
    bus.on("psToSprite", () => {
      t.shuipump.psToSprite();
    });
    bus.on("close", () => {
      t.shuipump.removeSprite(t.shuipump.psSprite);
    });
    bus.on("monitoring", () => {
      setTimeout(() => {
        t.border.showMit(true); //点击返回按钮后外场监控显示
      }, 1000);
    });
    bus.on("getOutStatus", (res) => {
      res.fault = [...res.fault, ...res.beyondAlarm];
      t.ponintstate.backstagePointMapState = res;
      // 环境监测贴图
      t.ponintstate.pointStateMap(
        res.normal,
        t.ponintstate.environmentPoint,
        "正常"
      );
      t.ponintstate.pointStateMap(
        res.fault,
        t.ponintstate.environmentPoint,
        "告警"
      );
      t.ponintstate.pointStateMap(
        res.standby,
        t.ponintstate.environmentPoint,
        "待机"
      );
      let judge, judgeArray;
      judgeArray = [...res.normal, ...res.fault, ...res.standby];
      judgeArray.map((i) => {
        judge = i;
      });
      let judgeModel = t.runScene.modelEx.getModel(judge);
      if (judgeModel.parent.name === "外场监控") {
        // 监控中心贴图
        t.ponintstate.cameraPointStateMap(
          res.normal,
          t.ponintstate.monitoringPoint,
          "正常"
        );
        t.ponintstate.cameraPointStateMap(
          res.fault,
          t.ponintstate.monitoringPoint,
          "告警"
        );
        t.ponintstate.cameraPointStateMap(
          res.standby,
          t.ponintstate.monitoringPoint,
          "待机"
        );
      }
    });
    bus.on("substationData", (res) => {
      t.pdjevent.clickMethod = false;
      let model = t.runScene.modelEx.getModel(res);
      let name, childrenName;
      if (
        model.parent.parent.name.indexOf("PDJ_A") !== -1 ||
        model.parent.parent.name.indexOf("PDJ_D") !== -1
      ) {
        name = model.parent.parent.name;
        childrenName = model.parent.name;
        t.pdjevent.clickModel = true;
        t.runScene.multipSelector.setEmpty();
        t.runScene.multipSelector.add(model);
      } else {
        name = model.parent.parent.parent.name;
        childrenName = model.parent.parent.name;
        t.pdjevent.clickModel = true;
        t.runScene.multipSelector.setEmpty();
        t.runScene.multipSelector.add(model);
      }
      name = name.split("_");
      let myName = name[0].toLowerCase() + name[1];
      t.pdjevent.setPdjA(
        t.pdjevent[myName],
        t.pdjevent[`${myName}1`],
        childrenName,
        res
      );
    });
    bus.on("carInfor", (res) => {
      t.ponintstate.searchCarView(res);
    });
    bus.on("nowPath1", (res) => {
      if (res.length == 0) {
        t.ponintstate.undergroundPoint = null;
        t.map.changeMap(
          t.ponintstate.flag,
          t.ponintstate.undergroundPointMap["正常"],
          "map"
        );
        return;
      }
      res.sort(function (a, b) {
        return a - b;
      });
      res.forEach((i) => {
        if (i === "05" || i === "06") {
          t.ponintstate.undergroundPoint = i;
          t.map.changeMap(
            t.ponintstate.flag,
            t.ponintstate.undergroundPointMap[i],
            "map"
          );
        } else {
          t.ponintstate.undergroundPoint = null;
          t.map.changeMap(
            t.ponintstate.flag,
            t.ponintstate.undergroundPointMap["正常"],
            "map"
          );
        }
      });
    });
    bus.on("initDom1", () => {
      t.map.changeMap(
        t.ponintstate.flag,
        t.ponintstate.undergroundPointMap["正常"],
        "map"
      );
    });
    bus.on("to2Dui", (dom) => {
      t.border.domToMySprite(dom);
    });
    bus.on("elevator", (buildding, name) => {
      bus.emit("dialogNumber", name);
      t.floor.showLift(true);
      t.runScene.modelEx.camAnima(
        t.runScene.modelEx.getCamLocal(),
        t.floor.Builddings[buildding].view,
        1
      );
    });
    bus.on("initCar", () => {
      if (t.ponintstate.cliclCar) {
        t.ponintstate.cliclCar.material.color = new THREE.Color(
          `rgb(7,138,159)`
        );
      }
    });
    bus.on("pipelineIsShow", () => {
      t.parking.pipeline.visible = true;
    });
    bus.on("chooseGround", (res) => {
      let model = t.runScene.modelEx.getModel(res);
      if (model.parent?.parent?.name == "环境监测点位") {
        let { normal, fault, standby } = t.ponintstate.backstagePointMapState;
        t.ponintstate.pointStateMap(
          normal,
          t.ponintstate.clickEnvironmentPoint,
          "正常",
          model.name
        );
        t.ponintstate.pointStateMap(
          fault,
          t.ponintstate.clickEnvironmentPoint,
          "告警",
          model.name
        );
        t.ponintstate.pointStateMap(
          standby,
          t.ponintstate.clickEnvironmentPoint,
          "待机",
          model.name
        );
        t.border.setSpritePosition(model);
        bus.emit("empNumber", model.name);
        // let point = t.runScene.modelEx.getWorldLocal(
        //     model
        // );
        // t.runScene.modelEx.camAnima(
        //     t.runScene.modelEx.getCamLocal(), {
        //     cx: point.x,
        //     cy: point.y ,
        //     cz: point.z,
        //     tx: point.x,
        //     ty: point.y,
        //     tz: point.z,
        // },
        //     0.5,
        //     () => {
        //     }
        // );
      }
    });
    bus.on("pdjClickIsshow", () => {
      t.runScene.multipSelector.setEmpty();
    });
    bus.on("clearTiemr", () => {
      t.parking.clearTimer();
    });
    // bus.on('')
    // bus.on("underground", (isShow, which) => {
    //     t.switchover.underground(isShow, which);
    // });
    // bus.on("B3Click", (yon) => {
    //     t.floorExplosion.controlFloorBQOp(yon);
    // });
    // bus.on("backB3", () => {
    //     t.floorExplosion.isShowBuilding("B3", true);
    //     bus.emit("unChosenB3");
    // });
    // bus.on("openLiftAnima", () => {
    //     t.floorExplosion.returnBuilding();
    //     t.sceneAnima.openLiftAnima();
    // });
    // bus.on("closeLiftAnima", () => {
    //     t.sceneAnima.closeLiftAnima();
    // });
    // bus.on("evPonits", (isShow) => {
    //     t.border.evPointsSpriteVisable(isShow);
    //     if (!isShow) {
    //         t.border.evInfoSpriteVisible(false);
    //     }
    //     t.border.domToEvInfo();
    // });
    // bus.on("closeEvpoints", () => {
    //     t.border.evInfoSpriteVisible(false);
    // });
    // bus.on("PDJ", () => {
    //     t.border.domToPDJ();
    // });
    // bus.on("parking", (isShow) => {
    //     t.switchover.showParking(isShow);
    // });
  }
  //触发
  emit(fun, param) {
    param != null ? bus.emit(fun, param) : bus.emit(fun);
  }
}
// 封装动画的Promise
const pmsAnima = (map) => {
  const { begin, end, time, onUpdate, onDone } = map;
  return new Promise((s) => {
    Utils.anima(begin, end, time, onUpdate, () => {
      onDone();
      s();
    });
  });
};
//递归获取子元素
const lookFor = (Group, map) => {
  if (Group.children && Group.children[0]) {
    Group.children.map((i) => {
      lookFor(i, map);
    });
  } else {
    map.push(Group);
  }
};
//获取组中所有子元素
const getAllChildrenModel = (Group) => {
  let childrenMap = [];
  lookFor(Group, childrenMap);
  return childrenMap;
};
export default Change;

/* 常用run-scene-v--API 详细的github自取
   版本更新飞书自查
*/

//cx:-2014.6447061988497, cy:1361.9921989981135, cz:-55.95814413453695, tx:232.4422, ty:38.549088, tz:-762.233145

/**
 *
 *
 * 获取模型
 * t.runScene.modelEx.getModel('');
 *
 * 基本的场景配置
 * controls.maxPolarAngle = Math.PI / 2 - 0.2;
 * controls.screenSpacePanning = false;
 *
 * 转dom
 * Utils.domTo3DSprite(dom);
 * Utils.domTo2Dui(dom);
 * Utils.domTo3Dui(dom);
 *
 * 相机当前位置以及视角
 * Utils.getCamAnimaData()
 *
 * 宏任务(自带清计时器)
 * Utils.getMacro(()={},time)
 *
 * 补帧动画
 * Utils.anima({},{},time,(data)=>{},()=>{})
 *
 * */

//pdj:cx:11.178887515655285, cy:-491.1690515268981, cz:4.059208434807735, tx:0.574133, ty:-499.048716, tz:0.81701
//SBF:cx:-16.065358208221173, cy:-493.7924185476832, cz:2.958418611215044, tx:0.574133, ty:-499.048716, tz:0.81701
//XFBF:cx:-12.20758303743191, cy:-493.1066373516456, cz:3.317749871628157, tx:0.8626588099105101, ty:-498.5480401014716, tz:1.1696066234904037

//1:-6 2:-1 3:3 4:7 5:11
// 水:
// 04 - A02 - 020 - WM - 26 - 040205;
// 04 - A03 - 021 - WM - 26 - 040304;
// 04 - A03 - 021 - WM - 26 - 040305;
// 04 - A04 - 022 - WM - 26 - 040404;
// 04 - A04 - 022 - WM - 26 - 040406;
// 04 - A05 - 023 - WM - 26 - 040505;
// 04 - A05 - 023 - WM - 26 - 040506;
// 03 - A03 - 015 - WM - 26 - 030304;
// 03 - A04 - 016 - WM - 26 - 030403;
// 03 - A05 - 017 - WM - 26 - 030506;
// 02 - A03 - 009 - WM - 26 - 020305;
// 02 - A04 - 010 - WM - 26 - 020406;
// 02 - A04 - 010 - WM - 26 - 020405;
// 02 - A05 - 011 - WM - 26 - 020504;
// 02 - A05 - 011 - WM - 26 - 020506;
// 02 - A05 - 011 - WM - 26 - 020505;

//电:
// 04-A01-019-GD-03-000005
// 03-A02-014-GD-03-000018
// 03-A02-014-GD-03-000019
// 03-A02-014-GD-03-000017
// 03-A03-015-GD-03-000010
